/** @format */

import React, { useEffect, useState } from "react";
import axios from "axios";
import { header } from "../../../../../components/api/Header";
import { getEnv } from "../../../../../lib/env";

function Page2({ date }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (!date) return;

      try {
        const res = await axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/republik/amudaryo/linemap?date=${date}`,
          header() || undefined
        );
        setData(res.data);
      } catch (error) {
        console.error("Xato:", error);
        alert("Serverga ulanishda xatolik");
      }
    };

    fetchData();
  }, [date]);

  return (
    <div className='card statistic-card w-100'>
      <div className='container-fluid amu-sxema'>
        <div className='amud-svg'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='100%'
            height='80vh'
            viewBox='0 0 1920 1080'>
            <g transform='translate(651.041 326.992)'>
              <path
                fill='#FFF'
                d='M-651.59-328.05h1920v1080h-1920z'
                className='st0'
                opacity='0.07'></path>
              <path
                fill='#F7F6C3'
                d='m1158 187.281-17.4-27.2s-26.7-26.6-32.1-41.6 14.7-80.9 14.7-87.5-30.2-24.3-30.2-24.3l-54.8-19.1-49.604-16.1-30.4-24.6h-48l-24.4 17.3-64.9 23.3h-29.8l-33.1 3.4-19.6 8.8-5-4.1-12.5-8.1-8-5.4-21.2-4.7-18.9 6.1h-29.1s-19.7 2-21.3.6-30.1 0-30.1 0h-71c-2.4 0-24.8 3.4-24.8 3.4l-26.8 6.1-18.5 8.8-34.4 24.8-79.8 21.5-106.8 19.6-33.6 38.1 38.4 36.3 28.5 34.4 21.7 37.1-15.8 60.6s-51.2-.3-53.5-1.1-47.6-9.2-47.6-9.2l-38-27.1-28.2-23.2-19-4.5-65.4-6.5s-17-47.6-10.4-50.4 0-25.4 0-25.4l2.4-21.2 3.3-31.6-12-15.4-17.4-2.5h-36.5l-45.6-2.8-41.696-3.7-32.3 7.3-15.8 5.4-3.9 36-10.2 35.3 3.7 41.7-12 21.9-19.2 30-33.9 9.5-24 19.1-37.6 16.2-36.7 17.2-23.2 18.9-9.9 33.4-21 12.2-44.1 8.7-62.5-5.2-46.6-.7-65.8 12.9-14.6 4.7v378.6h1920v-521.1l-50.5-28.3-26.4-9.1z'
                className='st1'
                opacity='0.75'></path>
              <path
                fill='none'
                stroke='#7EA641'
                strokeDasharray='12'
                strokeMiterlimit='10'
                strokeWidth='3'
                d='m-649.8 377.981 12.3-2.1 14.6-6.4 30.8-8.6 28.1-3.6 19.3-2.8 18.8 3.3 23.8 1.7 15.8 1.3 20.8-4.8 44.1-8.7 21-12.1 9.9-33.1 23.2-18.7 36.7-17 37.6-16.1 24-18.9 33.9-9.4 19.2-29.7 12-21.7-3.7-41.3 10.2-35 3.9-35.7 15.8-5.3 32.3-7.3 41.7 3.7 45.596 2.8h36.5l17.4 2.5 12 15.2-3.3 31.3-2.4 21s6.6 22.3 0 25.1 10.4 49.9 10.4 49.9l65.4 6.5 19 4.4 28.2 22.9 38 26.8s45.2 8.3 47.6 9.1c2.3.8 53.5 1.1 53.5 1.1l15.8-59.9-21.8-36.5-28.5-34-38.4-35.9 33.6-37.7 106.6-19.2 79.8-21.3 34.4-24.5 18.5-8.7 26.8-6s22.3-3.3 24.8-3.3h71s28.5-1.3 30.1 0 21.3-.6 21.3-.6h29.1l18.9-6 21.2 4.6 8 5.3 12.5 8 5 4 19.6-8.7 33.1-3.3h29.8l64.9-23.1 24.4-17.2h48l30.4 24.3 49.604 15.9 54.8 18.9s30.2 17.5 30.2 24-20.1 71.8-14.7 86.6c5.3 14.8 32.1 41.2 32.1 41.2l17.4 26.9 11.3 6.5 14.8 1.6 35.8 12 18.1 9s10.9 6.1 13.1 7.3 12.6 7.1 12.6 7.1l8.8 4.9'
                className='st2'></path>
              <path
                fill='#4457A6'
                d='M-557.7 36.181h1699.8v17.5H-557.7zM264.496-150.43h9.2v128.114h-9.2zM375.996 96.481h9.1v141.5h-9.1zM297.596 107.381h9.1v258.6h-9.1z'
                className='st3'></path>
              <path
                fill='#4457A6'
                d='M-20.104 52.181h9.1v217.361h-9.1zM-98.604 52.481h9.1v313.5h-9.1zM-176.7 51.781h9.1v225.1h-9.1zM-295.6-141.02h9.1v183.7h-9.1zM-341.6-141.02h9.1v183.7h-9.1zM218.896 95.751h9.1v95.446h-9.1z'
                className='st3'></path>
              <path
                fill='#4457A6'
                d='M357.896 107.381h-109.9c-22.7 0-41.2-18.4-41.2-41.2v-47.4c0-22.7 18.4-41.2 41.2-41.2h109.8c22.7 0 41.2 18.4 41.2 41.2v47.4c0 22.7-18.4 41.2-41.1 41.2'
                className='st3'></path>
              <text
                x='180.672'
                y='-205.22'
                className='st4 st5'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "38.5373px", whiteSpace: "pre" }}>
                O’ng qirg’oq k-li
              </text>
              <text
                fill='#2E3192'
                className='st8 st6 st9'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='matrix(1.12481 0 0 1.09091 186.335 -170.105)'>
                {`${data[677] ? data[677]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <path
                fill='#4457A6'
                d='M676.941-154.12h7.824V44.782h-7.824z'
                className='st3'></path>
              <text
                className='st4 st11'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ whiteSpace: "pre" }}
                transform='translate(602.83 -194.237)'>
                ABMK
              </text>
              <text
                fill='#2E3192'
                className='st8 st6 st12'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(600.82 -164.184)'>
                {`${data[110] ? data[110]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <path
                fill='#4457A6'
                d='M856.911-154.44h8.618V38.364h-8.618z'
                className='st3'></path>
              <text
                x='796.772'
                y='-193.69'
                className='st4 st14'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "55.5301px", whiteSpace: "pre" }}>
                KMK
              </text>
              <path
                fill='#4457A6'
                d='M953.662-151.38h8.186V37.785h-8.186zM898.296 53.781h9.2v150.7h-9.2z'
                className='st3'></path>
              <text
                x='1583.55'
                y='142.515'
                className='st4 st16'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23.171'
                style={{ lineHeight: "44.8352px", whiteSpace: "pre" }}
                transform='matrix(1.09018 0 0 1.12209 -788.335 -354.187)'>
                Amu-zang
              </text>
              <text
                fill='#2E3192'
                className='st8 st6 st17'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(954.78 -163.838)'>
                {`${data[5] ? data[5]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <path
                fill='none'
                stroke='#000'
                strokeMiterlimit='10'
                d='M152.705 176.021H17.781c-2.375 0-4.385-2.043-4.385-4.458V116.94c0-2.415 2.01-4.459 4.385-4.459h134.924c2.375 0 4.385 2.044 4.385 4.459v54.623c0 2.508-2.01 4.458-4.385 4.458Z'
                className='st15'></path>
              <text
                x='18.796'
                y='135.376'
                className='st4 st19'
                fontFamily='Inter'
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "40.5155px", whiteSpace: "pre" }}>
                Xorazm N/S
              </text>
              <path
                fill='#4457A6'
                d='M-278.2 53.181h7.3v74.5h-7.3z'
                className='st3'></path>
              <text
                x='676.467'
                y='494.648'
                fill='#2E3192'
                className='st8 st6 st21'
                fontFamily={"Inter"}
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(-653.206 -328.177)'>
                {`${data[184] ? data[184]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <path
                fill='#4457A6'
                d='M-502 52.081h9.1v81h-9.1z'
                className='st3'></path>
              <path
                fill='#FFF'
                stroke='#000'
                strokeMiterlimit='10'
                d='M279.88 250.199H138.461c-2.418 0-4.416-1.812-4.416-4.007v-51.327c0-2.194 1.998-4.007 4.416-4.007H279.88c2.418 0 4.416 1.813 4.416 4.007v51.327c0 2.195-2.103 4.007-4.416 4.007Z'
                className='st23'></path>
              <text
                x='143.265'
                y='213.568'
                className='st4 st24'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "37.475px", whiteSpace: "pre" }}>
                Pitnak kanali
              </text>
              <text
                fill='#2E3192'
                className='st8 st6 st26'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(147.953 240.71)'>
                {`${data[680] ? data[680]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <text
                x='730.755'
                y='345.097'
                fill='#2E3192'
                className='st8 st6 st28'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ lineHeight: "21.7595px", whiteSpace: "pre" }}
                transform='translate(-649.804 -326.719)'>
                {`${data[676] ? data[676]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <text
                x='218.46'
                y='85.987'
                fill='#FFF'
                className='st30 st4 st31'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='20'
                style={{ lineHeight: "20.4363px", whiteSpace: "pre" }}
                transform='matrix(1 0 0 1.50161 -2.68 -43.83)'>
                Tuyamo’yin SO
              </text>
              <g transform='translate(-649.804 -326.719)'>
                <path d='M679 329.8c0-4-3.2-7.2-7.2-7.2s-7.2 3.2-7.2 7.2z'></path>
                <circle
                  cx='671.7'
                  cy='329.8'
                  r='7.2'
                  fill='none'
                  stroke='#000'
                  strokeMiterlimit='10'
                  strokeWidth='0.25'
                  className='st32'></circle>
              </g>
              <path d='M20.996 10.281h1.9v15.7h-1.9z'></path>
              <g transform='translate(-649.804 -326.719)'>
                <path d='M662.2 329.8c0-4-3.2-7.2-7.2-7.2s-7.2 3.2-7.2 7.2z'></path>
                <circle
                  cx='655'
                  cy='329.8'
                  r='7.2'
                  fill='none'
                  stroke='#000'
                  strokeMiterlimit='10'
                  strokeWidth='0.25'
                  className='st32'></circle>
              </g>
              <path d='M4.196 10.281h1.9v15.7h-1.9z'></path>
              <g transform='translate(-649.804 -326.719)'>
                <path d='M645.4 329.8c0-4-3.2-7.2-7.2-7.2s-7.2 3.2-7.2 7.2z'></path>
                <circle
                  cx='638.2'
                  cy='329.8'
                  r='7.2'
                  fill='none'
                  stroke='#000'
                  strokeMiterlimit='10'
                  strokeWidth='0.25'
                  className='st32'></circle>
              </g>
              <path d='M-12.504 10.281h1.9v15.7h-1.9z'></path>
              <path
                fill='#DDD3C5'
                d='M-377.47 77.96c-19.98 19.755-52.28 19.755-72.15 0-19.99-19.754-19.99-51.674 0-71.317 19.98-19.755 52.28-19.755 72.15 0 19.99 19.643 19.99 51.563 0 71.317'
                className='st33'></path>
              <path
                fill='#C6BAAB'
                d='M30.478 673.951c-8.7 8.7-22.7 8.7-31.4 0s-8.7-22.7 0-31.4 22.7-8.7 31.4 0 8.7 22.7 0 31.4'
                className='st34'></path>
              <text
                x='-450.18'
                y='29.448'
                className='st35 st36'
                fontFamily='Poppins-Medium'
                fontSize='9.9'
                style={{
                  whiteSpace: "pre",
                  lineHeight: "15.8576px",
                  perspectiveOrigin: "0 0",
                }}
                transform='matrix(1.30611 0 0 1.45714 126.324 -13.145)'>
                Taxiatosh G/U
              </text>
              <path
                fill='#EF4136'
                d='M-174.4.681v13.8h-16.3v14.6h-1.6V.681z'
                className='st37'></path>
              <text
                x='355.942'
                y='-82.911'
                className='st4 st38'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='26'
                style={{ lineHeight: "27.0128px", whiteSpace: "pre" }}
                transform='matrix(.93138 0 0 .92063 -14.012 -23.414)'>
                Darganata
              </text>
              <path
                fill='none'
                stroke='#000'
                strokeMiterlimit='10'
                d='M468.817-38.742H317.176c-3.161 0-5.689-3.206-5.722-6.893l-.624-72.475c-.034-3.84 2.572-6.89 5.6-6.89h151.642c3.157 0 5.688 3.22 5.72 6.89l.625 72.475c.035 4.007-2.31 6.893-5.6 6.893Z'
                className='st15'></path>
              <g
                fill='#2E3192'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'>
                <text
                  x='1142.57'
                  y='270.884'
                  className='st8 st6 st39'
                  style={{ whiteSpace: "pre" }}
                  transform='translate(-819.389 -343.587)'>
                  {`H - ${data[667] ? data[667]["suvi"] : "0"} sm`}
                </text>
                <text
                  x='1142.55'
                  y='294.788'
                  className='st8 st6 st39'
                  style={{ whiteSpace: "pre" }}
                  transform='translate(-819.389 -343.587)'>
                  {`Q - ${data[668] ? data[668]["suvi"] : "0"} m\u00B3/s`}
                </text>
              </g>
              <text
                x='527.726'
                y='-72.316'
                className='st4 st41'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='26'
                style={{ lineHeight: "27.5189px", whiteSpace: "pre" }}
                transform='matrix(.95493 0 0 .90028 -6.237 -15.335)'>
                Charjou G/p
              </text>
              <path
                fill='none'
                stroke='#000'
                strokeMiterlimit='10'
                d='M633.137-38.375H497.385c-2.746 0-5.134-2.338-5.134-5.291v-55.006c0-2.828 2.268-5.288 5.134-5.288h155.752c2.746 0 5.135 2.33 5.135 5.288v55.006c0 3.076-2.269 5.291-5.135 5.291Z'
                className='st15'></path>
              <text
                fill='#2E3192'
                className='st8 st6 st42'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(500.923 -45.91)'>
                {`H - ${data[672] ? data[672]["suvi"] : "0"} sm`}
              </text>
              <text
                x='718.407'
                y='-98.916'
                className='st4 st43'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "27.2714px", whiteSpace: "pre" }}>
                Kerki G/p
              </text>
              <path
                fill='none'
                stroke='#000'
                strokeMiterlimit='10'
                d='M830.84-36.647H703.273c-2.555 0-4.778-3.216-4.778-6.914v-72.519c0-3.7 2.223-6.91 4.778-6.91H830.84c2.556 0 4.779 3.21 4.779 6.91v72.519c.222 3.859-2.001 6.914-4.779 6.914Z'
                className='st15'></path>
              <g
                fill='#2E3192'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'>
                <text
                  x='1400.99'
                  y='271.294'
                  className='st8 st6 st44'
                  style={{ lineHeight: "20.7134px", whiteSpace: "pre" }}
                  transform='translate(-698.95 -343.843)'>
                  {` H - ${data[650] ? data[650]["suvi"] : "0"} sm`}
                </text>
                <text
                  x='1400.99'
                  y='298.03'
                  className='st8 st6 st44'
                  style={{ whiteSpace: "pre" }}
                  transform='translate(-698.95 -343.843)'>
                  {`Q - ${data[651] ? data[651]["suvi"] : "0"} m\u00B3/s`}
                </text>
              </g>
              <path
                fill='#FFF'
                stroke='#000'
                strokeMiterlimit='10'
                d='M1118.64-30.019H998.425c-2.438 0-4.452-2.157-4.452-4.77v-50.763c0-2.612 2.014-4.769 4.452-4.769h135.215c2.44 0 4.45 2.157 4.45 4.769v50.536c.22 2.84-1.9 4.997-4.45 4.997Z'
                className='st23'></path>
              <text
                x='1727.26'
                y='287.271'
                fill='#2E3192'
                className='st8 st6 st46'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ lineHeight: "19.0896px", whiteSpace: "pre" }}
                transform='translate(-720.385 -327.799)'>
                {`H - ${data[645] ? data[645]["suvi"] : "0"} sm`}
              </text>
              <path d='M86.86 27.57h85.805v2.199H86.86z'></path>
              <path d='m79.126 28.669 8.61 4.032v-8.187z'></path>
              <text
                x='1067.55'
                y='351.944'
                fill='#2E3192'
                className='st8 st6 st28'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(-647.754 -263.628)'>
                {`${data[673] ? data[673]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <path d='M416.857 60.037h65.205v2.328h-65.205z'></path>
              <path d='m410.98 61.2 6.543 4.398v-8.795zM582.796 53.781h1.8v57.1h-1.8z'></path>
              <path d='m583.796 115.981-3.4-5.7h6.7zM566.996 53.781h1.8v57.1h-1.8z'></path>
              <path d='m567.896 115.981-3.3-5.7h6.7zM549.296 53.781h1.8v57.1h-1.8z'></path>
              <path d='m550.296 115.981-3.4-5.7h6.7zM582.896-.519h1.8v36.8h-1.8z'></path>
              <path d='m583.796-3.819-3.4 3.6h6.8zM567.096-.519h1.8v36.8h-1.8z'></path>
              <path d='m567.996-3.819-3.4 3.6h6.8zM549.396-.519h1.8v36.8h-1.8z'></path>
              <path d='m550.296-3.819-3.4 3.6h6.8zM531.796 53.681h1.8v57.1h-1.8z'></path>
              <path d='m532.696 115.981-3.4-5.7h6.8z'></path>
              <text
                fill='#2E3192'
                className='st8 st6 st28'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(-556.503 19.129)'>
                {`${data[176] ? data[176]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <path d='M-548.866 26.259h73.313v1.8h-73.313z'></path>
              <path d='m-555.474 27.159 7.231 3.4v-6.8z'></path>
              <ellipse
                cx='-191.7'
                cy='28.681'
                fill='#EF4136'
                className='st48'
                opacity='0.39'
                rx='22.3'
                ry='4.7'></ellipse>
              <ellipse cx='5.996' cy='28.381' rx='28' ry='4.7'></ellipse>
              <g transform='translate(-649.804 -326.719)'>
                <path d='M769.3 414.5c0 4-3.2 7.2-7.2 7.2s-7.2-3.2-7.2-7.2z'></path>
                <circle
                  cx='762.1'
                  cy='414.5'
                  r='7.2'
                  fill='none'
                  stroke='#000'
                  strokeMiterlimit='10'
                  strokeWidth='0.25'
                  className='st32'></circle>
              </g>
              <path d='M111.296 64.781h1.9v15.7h-1.9z'></path>
              <g transform='translate(-649.804 -326.719)'>
                <path d='M752.5 414.5c0 4-3.2 7.2-7.2 7.2s-7.2-3.2-7.2-7.2z'></path>
                <circle
                  cx='745.3'
                  cy='414.5'
                  r='7.2'
                  fill='none'
                  stroke='#000'
                  strokeMiterlimit='10'
                  strokeWidth='0.25'
                  className='st32'></circle>
              </g>
              <path d='M94.496 64.781h1.9v15.7h-1.9z'></path>
              <g transform='translate(-649.804 -326.719)'>
                <path d='M735.8 414.5c0 4-3.2 7.2-7.2 7.2s-7.2-3.2-7.2-7.2z'></path>
                <circle
                  cx='728.5'
                  cy='414.5'
                  r='7.2'
                  fill='none'
                  stroke='#000'
                  strokeMiterlimit='10'
                  strokeWidth='0.25'
                  className='st32'></circle>
              </g>
              <path d='M77.796 64.781h1.9v15.7h-1.9z'></path>
              <ellipse cx='96.396' cy='62.381' rx='28' ry='4.7'></ellipse>
              <path
                fill='#EF4136'
                d='M-229.7-37.119h2.4v66.2h-2.4z'
                className='st37'></path>
              <path
                fill='#EF4136'
                d='M-213.6 28.581v.2q0 .3-.3.3h-15.6v-.8h15.6q.3 0 .3.3'
                className='st48'
                opacity='0.39'></path>
              <path d='M27.296 27.481h29.3v1.8h-29.3z'></path>
              <path d='M54.796-32.319h4.5v61.6h-4.5zM45.896 61.481h29.3v1.8h-29.3zM45.896 63.281h4.3v49.2h-4.3z'></path>
              <path
                fill='#EF4136'
                d='M657.596 2.681v13.8h-16.3v14.6h-1.6v-28.4z'
                className='st37'></path>
              <ellipse
                cx='640.296'
                cy='29.381'
                fill='#EF4136'
                className='st48'
                opacity='0.39'
                rx='22.3'
                ry='4.7'></ellipse>
              <g fill='#EF4136' transform='translate(-1499.89 -241.778)'>
                <path
                  d='M982 883.5v17.6h-20.8v18.5h-2v-36.1z'
                  className='st37'></path>
                <ellipse
                  cx='960'
                  cy='917.4'
                  className='st48'
                  opacity='0.39'
                  rx='28.4'
                  ry='5.9'></ellipse>
              </g>
              <path
                fill='#EF4136'
                d='M600.496-37.83h2.6v67.611h-2.6z'
                className='st37'></path>
              <path
                fill='#EF4136'
                d='M618.496 29.281v.2q0 .3-.3.3h-15.6v-.8h15.6c.1 0 .3.1.3.3'
                className='st48'
                opacity='0.39'></path>
              <path
                fill='#EF4136'
                d='M808.896 2.781v13.8h-16.3v14.6h-1.5v-28.4z'
                className='st37'></path>
              <ellipse
                cx='791.596'
                cy='29.381'
                fill='#EF4136'
                className='st48'
                opacity='0.39'
                rx='22.3'
                ry='4.7'></ellipse>
              <path
                fill='#EF4136'
                d='M753.596-36.103h2.6v65.884h-2.6z'
                className='st37'></path>
              <path
                fill='#EF4136'
                d='M769.796 29.281v.2q0 .3-.3.3h-15.6v-.8h15.6c.1 0 .3.1.3.3'
                className='st48'
                opacity='0.39'></path>
              <path
                fill='#EF4136'
                d='M1073.4 2.281v13.8h-16.3v14.6h-1.5v-28.4z'
                className='st37'></path>
              <ellipse
                cx='1056.1'
                cy='28.981'
                fill='#EF4136'
                className='st48'
                opacity='0.39'
                rx='22.3'
                ry='4.7'></ellipse>
              <path
                fill='#EF4136'
                d='M1018.096-29.619h2.4v59h-2.4z'
                className='st37'></path>
              <path
                fill='#EF4136'
                d='M1034.3 28.881v.2q0 .3-.3.3h-15.6v-.8h15.6c.1 0 .3.1.3.3'
                className='st48'
                opacity='0.39'></path>
              <path
                fill='#EF4136'
                d='M504.177 1.158v13.8h-16.3v14.6h-1.6v-28.4z'
                className='st37'></path>
              <ellipse
                cx='487.654'
                cy='29.541'
                fill='#EF4136'
                className='st48'
                opacity='0.39'
                rx='22.3'
                ry='4.7'></ellipse>
              <path
                fill='#EF4136'
                d='M447.791-38.264h2v68.045h-2z'
                className='st37'></path>
              <path
                fill='#EF4136'
                d='M465.736 29.299v.2q0 .3-.3.3h-15.6v-.8h15.6q.3 0 .3.3'
                className='st48'
                opacity='0.39'></path>
              <path
                fill='#FFF200'
                stroke='#000'
                strokeMiterlimit='10'
                d='M-588.1-313.02h320.2v61.7h-320.2z'
                className='st49'
                opacity='0.29'></path>
              <text
                x='-575.72'
                y='-265.78'
                fill='#262262'
                className='st50 st4 st51'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='50'
                style={{ lineHeight: "63.5638px", whiteSpace: "pre" }}>
                {"O\u2018zbekiston"}
              </text>
              <path
                fill='#FFF200'
                stroke='#000'
                strokeMiterlimit='10'
                d='M-588.1 391.381h360.7v61.7h-360.7z'
                className='st49'
                opacity='0.29'></path>
              <text
                x='-575.98'
                y='436.642'
                fill='#262262'
                className='st50 st4 st51'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='50'
                style={{ lineHeight: "63.5638px", whiteSpace: "pre" }}>
                Turkmaniston
              </text>
              <text
                x='-581.99'
                y='599.176'
                className='st52 st35 st53'
                fontFamily='Poppins-Medium'
                fontSize='23'
                opacity='0.6'
                style={{ lineHeight: "40.8725px", whiteSpace: "pre" }}
                transform='matrix(1.08894 0 0 1.10814 86.46 -66.111)'>
                Shartli belgilar
              </text>
              <text
                x='-491.65'
                y='673.027'
                className='st6 st54'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ lineHeight: "31.7853px", whiteSpace: "pre" }}>
                Suv o’lchash posti
              </text>
              <text
                x='-213.9'
                y='669.892'
                className='st6 st54'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ lineHeight: "31.7853px", whiteSpace: "pre" }}>
                Nasos stansiya
              </text>
              <text
                className='st6 st54'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(66.037 669.1)'>
                Gidrouzel
              </text>
              <text
                className='st6 st54'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(716.048 669.394)'>
                Daryo
              </text>
              <text
                className='st6 st54'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(381.718 671.826)'>
                Kanal
              </text>
              <text
                className='st6 st54'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(999.743 669.199)'>
                Davlat chegarasi
              </text>
              <path
                fill='none'
                stroke='#000'
                strokeMiterlimit='10'
                d='M-591.34 553.978h1808.69v172.303H-591.34z'
                className='st15'></path>
              <g transform='translate(-1219.77 -329.939)'>
                <path d='M970.6 976c0-5.1-4.1-9.2-9.2-9.2s-9.2 4.1-9.2 9.2z'></path>
                <circle
                  cx='961.4'
                  cy='976'
                  r='9.2'
                  fill='none'
                  stroke='#000'
                  strokeMiterlimit='10'
                  className='st15'></circle>
              </g>
              <path d='M-259.57 655.261h2.5v20h-2.5z'></path>
              <path
                fill='#4457A6'
                d='M571.133 644.756H676.71v31.4H571.133zM267.452 660.329h76.1v13.3h-76.1z'
                className='st3'></path>
              <path
                fill='#7EA641'
                d='M970.165 664.081h-12v-3h12zm-23.8 0h-12.2v-3h12.2zm-24 0h-12.2v-3h12.2zm-24 0h-12.2v-3h12.2zm-24 0h-12.2v-3h12.2z'
                className='st55'></path>
              <g transform='translate(-649.804 -326.719)'>
                <linearGradient
                  id='a'
                  x1='893'
                  x2='893'
                  y1='739.112'
                  y2='748.578'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path
                  fill='url("#a")'
                  d='M886.5 331.4h13v9.5h-13z'
                  className='st56'></path>
                <linearGradient
                  id='b'
                  x1='881.725'
                  x2='890.524'
                  y1='706.065'
                  y2='731.302'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path
                  fill='url(#b)'
                  d='M885.9 381.3h-13l13.6-40.4h13.1z'></path>
                <linearGradient
                  id='c'
                  x1='885.922'
                  x2='905.122'
                  y1='718.9'
                  y2='718.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path
                  fill='url(#c)'
                  d='M905.1 340.9v40.4h-19.2l.8-2.2 12.9-38.2z'></path>
                <linearGradient
                  id='d'
                  x1='899.6'
                  x2='905.139'
                  y1='743.85'
                  y2='743.85'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path fill='url(#d)' d='M899.6 331.4h5.5v9.5h-5.5z'></path>
                <g fill='#FFF'>
                  <path
                    d='M888.1 355.7c-.7 1.5-1.6 2.3-2.6 2.4l-.4.9c1.5-.1 3.1-1.3 4-3.3zm-.1-4.1-.4.9c1 .1 1.3 1 .7 2.7h1c.9-2.2.3-3.5-1.3-3.6m-4.6 3.6h1c.7-1.7 1.7-2.6 2.8-2.7l.4-.9c-1.7.1-3.3 1.4-4.2 3.6m.9.5h-1c-.6 2 0 3.2 1.5 3.3l.4-.9c-1-.1-1.4-.9-.9-2.4M891.4 355.7l-1.3 3.3h1l1.3-3.3zm-.1-4.1-.4.9h1.7l-1 2.7h1l1.4-3.6z'
                    className='st30'></path>
                </g>
                <path
                  fill='#537898'
                  d='M902.7 361.2c0-.1-.1-.1 0 0 .6-2.9 1.1-5.2 1.5-6.8h.1v.1c-.4 1.5-1 3.8-1.6 6.7 0-.1 0 0 0 0'
                  className='st60'
                  opacity='0.4'></path>
                <linearGradient
                  id='e'
                  x1='916.6'
                  x2='916.6'
                  y1='732.844'
                  y2='739.112'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path
                  fill='url(#e)'
                  d='m928 340.9-.3.9h-16.3c-1.4 0-2.6 1.2-2.6 2.6v1.3c-1.3.3-2.5.8-3.6 1.4v-6.3H928z'></path>
                <path
                  fill='#40536C'
                  d='m927.7 341.8-2.4 6.9h-16.5v-4.3c0-1.4 1.2-2.6 2.6-2.6z'
                  className='st62'></path>
                <path
                  fill='#40536C'
                  d='m927.4 341.8-.1.4-2.2 6.4h-12.7v-4.3c0-1.4 1.2-2.6 2.6-2.6h12.4z'
                  className='st62'></path>
                <path
                  fill='#475D76'
                  d='m927.2 342.3-2.3 6.9h-9.5v-4.3c0-1.4 1.2-2.6 2.6-2.6z'
                  className='st63'></path>
                <linearGradient
                  id='f'
                  x1='909.3'
                  x2='909.3'
                  y1='698.7'
                  y2='734.646'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#79AACE'></stop>
                  <stop offset='0.584' stopColor='#95C9ED'></stop>
                  <stop offset='0.763' stopColor='#C9E5F8'></stop>
                  <stop offset='0.863' stopColor='#AEDAF5'></stop>
                  <stop offset='1' stopColor='#9CD0F1'></stop>
                </linearGradient>
                <path
                  fill='url(#f)'
                  d='m926.4 345.4-10.2 29.8-.8 2.3-.5 1.6-.7 2.2h-22c0-.7 0-1.4.1-2.2s.2-1.6.3-2.5c.4-2.1.9-4.4 1.6-6.6 1.6-5.5 3.8-11 5.2-15.5 1-3.2 3.1-5.8 5.9-7.4 1.1-.7 2.3-1.1 3.6-1.4q1.5-.3 3-.3z'></path>
                <linearGradient
                  id='g'
                  x1='892.03'
                  x2='926.379'
                  y1='716.65'
                  y2='716.65'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='0.198' stopColor='#FAFBFD'></stop>
                  <stop offset='0.338' stopColor='#EFF1F8'></stop>
                  <stop offset='0.459' stopColor='#DFE4F1'></stop>
                  <stop offset='0.57' stopColor='#C9D2E7'></stop>
                  <stop offset='0.675' stopColor='#AEBEDC'></stop>
                  <stop offset='0.774' stopColor='#8FA6D0'></stop>
                  <stop offset='0.869' stopColor='#6B8FC2'></stop>
                  <stop offset='0.958' stopColor='#3D78B4'></stop>
                  <stop offset='1' stopColor='#166EAE'></stop>
                </linearGradient>
                <path
                  fill='url(#g)'
                  d='m926.4 345.4-10.2 29.8-.8 2.3-.5 1.6-.7 2.2h-22c0-.7 0-1.4.1-2.2s.2-1.6.3-2.5c.4-2.1.9-4.4 1.6-6.6 1.6-5.5 3.8-11 5.2-15.5 1-3.2 3.1-5.8 5.9-7.4 1.1-.7 2.3-1.1 3.6-1.4q1.5-.3 3-.3z'
                  enableBackground='new'
                  opacity='0.4'></path>
                <g className='st66' opacity='0.5'>
                  <path
                    fill='#EAF4FC'
                    d='M894 378.4c.3-2.6.8-5.1 1.3-7.6h.1v.1c-.5 2.4-1 4.9-1.4 7.5.1 0 0 0 0 0M912.7 378.4q-.15 0 0 0c.3-2.6.8-5.1 1.3-7.6h.1v.1c-.6 2.4-1 4.9-1.4 7.5M896.6 365.8q-.15 0 0 0c.6-2.6 1.4-5.1 2.3-8h.1v.1c-1 2.8-1.7 5.4-2.4 7.9M915.6 365.8s-.1 0 0 0c.6-2.6 1.4-5.1 2.3-8h.1v.1c-.9 2.8-1.7 5.4-2.4 7.9M900.2 354.1q0-.15 0 0l.2-.7c.7-2.1 2.1-3.8 4.1-5.1.9-.6 2-1 3.1-1.3s2.2-.5 3.4-.5c0 0 .1 0 .1.1 0 0 0 .1-.1.1-4.9 0-9.1 2.7-10.5 6.8zc.1-.1.1 0 0 0M918.7 354.1q-.15-.15 0 0l.2-.7c.9-2.6 2.9-4.6 5.6-5.8h.1v.1c-2.7 1.2-4.7 3.2-5.6 5.8zc0-.1 0 0 0 0M903.5 378.4s-.1 0 0 0c0-.1.4-2.3 1-5.4h.1v.1c-.6 3-1.1 5.2-1.1 5.3M905.8 366.2c1-5.3 1.8-9.1 2.3-11.5h.1v.1c-.5 2.3-1.3 6.2-2.4 11.4q.15 0 0 0M911.3 349.2q0-.15 0 0c1.3-1.1 2.7-1.6 3.7-1.9 1.1-.3 1.8-.4 1.8-.4h.1v.1s-.8.1-1.8.4c-1 .2-2.5.8-3.8 1.8'
                    className='st67'></path>
                  <path
                    fill='#537898'
                    d='M907.2 379.7q-.15 0 0 0c.1-1.2.9-4.7 2.3-10.6h.1v.1c-1.4 5.8-2.2 9.4-2.4 10.5M911.1 362.3s0-.1 0 0c.3-1.5.6-3 1-4.6h.1v.1c-.3 1.5-.7 3-1.1 4.5.1 0 0 0 0 0M913.2 353.4c.4-1.4 1-2.6 1.8-3.5.7-.8 1.4-1.4 2.3-1.9 1.5-.8 2.7-.9 2.8-.9h.1v.1s-1.3.1-2.7.9c-1.4.7-3.2 2.3-4.3 5.3q.15 0 0 0M898.9 379.7c0-.6.3-1.7.5-3.2h.1v.1c-.2 1.4-.4 2.5-.6 3.1.1 0 0 0 0 0M900.6 371.4q-.15 0 0 0c.3-1.6.6-3.1.9-4.6h.1v.1c-.4 1.4-.7 3-1 4.5'
                    className='st60'
                    opacity='0.4'></path>
                </g>
                <linearGradient
                  id='h'
                  x1='904.2'
                  x2='904.2'
                  y1='698.681'
                  y2='706.526'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#B8DDF5'></stop>
                  <stop offset='0.601' stopColor='#D8EDFA'></stop>
                  <stop offset='1' stopColor='#E7F6FD'></stop>
                </linearGradient>
                <path
                  fill='url(#h)'
                  d='M917.7 381v.3h-26.2c-.5-.5-.8-1.2-.8-2.1v-.1c0-1.2.8-2.3 1.8-2.5h.4c.4 0 .8.1 1.1.3.1-.1.1-.3.2-.4.5-.7 1.2-1.4 2.2-1.8 1.5-.7 3.1-.7 4 0 .3-.5.8-1 1.4-1.1 1-.3 2.1.2 2.8 1.1.1-.2.3-.4.5-.5.3-.2.8-.2 1.3-.2 1 0 1.9.7 2.2 1.7.4.1.8.2 1.1.4.2-.6.9-1.1 1.6-1.1.9 0 1.7.7 1.7 1.7 0 .2 0 .4-.1.6.3-.1.6-.1.9-.1.5 0 1 .1 1.4.4h.2c.7.4 1.3.9 1.7 1.6.3.5.6 1.2.6 1.8'></path>
                <path
                  fill='#CBE5F7'
                  d='M893.3 381.3h-.5c-.1-.3-.2-.6-.2-.9 0-.4 0-.9.2-1.3.1-.3.3-.5.5-.7-.1.2-.2.5-.3.7-.1.3-.1.6-.1.9s.1.6.3.9c0 .2 0 .3.1.4M908.6 375.7c-.3-.1-.5-.1-.8-.1-.9 0-1.8.3-2.5.9 0-.1 0-.2-.1-.3.6-.4 1.4-.7 2.2-.7.5 0 .9.1 1.2.2M911.7 377.9l-.2.2c-.2-.4-.4-.8-.7-1.2-.2-.2-.5-.5-.8-.6-.1-.1-.2-.1-.3-.2l.6.3c.3.2.5.4.8.6zM910.7 379.1c-.2.4-.3.8-.3 1.3 0 .2 0 .5.1.7 0 .1 0 .1.1.2H905c0-.1.1-.1.1-.2.1-.2.2-.4.2-.7 0-.2-.1-.5-.2-.7s-.3-.4-.5-.6c.1 0 .1.1.2.1l.3.3c.3.3.5.7.5 1.1 0 .3.2.5.5.5h4.2v-.3c0-.6.1-1.2.4-1.7 0-.1.1-.2.1-.2 0 .1 0 .2-.1.2M902.9 379.7v.2c0 .5-.2 1-.4 1.4H897q-.3-.6-.3-1.5c0-.3 0-.5.1-.7l.3-.9c.1-.1.1-.2.2-.3s.1-.2.2-.3c-.1.1-.1.2-.2.3-.2.4-.3.8-.4 1.2v.5c0 .7.6 1.3 1.4 1.3h3.9c.2-.4.3-.8.3-1.3v-.8c-.1-.8-.6-1.4-1.1-1.9-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1c.2 0 .3.1.5.2.1-.4 0-.9-.1-1.2-.2-.3-.4-.6-.7-.8.4.2.8.5 1 1 .2.4.2.8.1 1.3.7.4 1.2 1.1 1.4 1.9v.8M895 377.9c-.4-.8-1.1-1-1.1-1 .1-.1.1-.3.2-.4.5.3.9.9.9 1.4'
                  className='st69'></path>
                <defs>
                  <path d='M1 1h1L1 2z'></path>
                </defs>
                <defs>
                  <path d='M-1-1h-1l1-1z'></path>
                </defs>
                <clipPath id='i'>
                  <path d='M1 1h1L1 2z' overflow='visible'></path>
                </clipPath>
                <clipPath id='k' clipPath='url(#i)'>
                  <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                </clipPath>
                <defs>
                  <filter
                    id='j'
                    width='32.1'
                    height='12.4'
                    x='888.3'
                    y='368.9'
                    filterUnits='userSpaceOnUse'>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'></feColorMatrix>
                  </filter>
                </defs>
                <mask
                  id='p'
                  width='32.1'
                  height='12.4'
                  x='888.3'
                  y='368.9'
                  maskUnits='userSpaceOnUse'>
                  <g className='st71' filter='url("#j")'>
                    <defs>
                      <path d='M1 1h1L1 2z'></path>
                    </defs>
                    <defs>
                      <path d='M-1-1h-1l1-1z'></path>
                    </defs>
                    <clipPath id='l' clipPath='url(#k)'>
                      <path d='M1 1h1L1 2z' overflow='visible'></path>
                    </clipPath>
                    <clipPath id='n' clipPath='url(#l)'>
                      <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                    </clipPath>
                    <linearGradient
                      id='m'
                      x1='904.35'
                      x2='904.35'
                      y1='698.681'
                      y2='710.901'
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'>
                      <stop offset='0' stopColor='#FFF'></stop>
                      <stop offset='1'></stop>
                    </linearGradient>
                    <path
                      fill='url(#m)'
                      d='M920.4 378.4c0 .2 0 .5-.1.7-.2.9-.8 1.7-1.6 2.2H890c-.8-.5-1.4-1.2-1.6-2.2 0-.2-.1-.5-.1-.7 0-1.5 1-2.7 2.3-3.2v-.6c0-2.2 1.5-4.1 3.5-4.7.4-.1.9-.2 1.4-.2.9 0 1.8.3 2.6.7.7-.9 1.8-1.5 3.1-1.5 1.5 0 2.7.8 3.4 2 .2-.1.4-.1.7-.2h.6c1.4 0 2.6.6 3.4 1.6.7-.6 1.6-.9 2.6-.9 2.2 0 4 1.6 4.3 3.7h.2c.3-.1.6-.1 1-.1 1.6.1 3 1.6 3 3.4'
                      clipPath='url(#n)'></path>
                  </g>
                </mask>
                <linearGradient
                  id='o'
                  x1='904.35'
                  x2='904.35'
                  y1='698.681'
                  y2='710.901'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='1'></stop>
                </linearGradient>
                <path
                  fill='url(#o)'
                  d='M920.4 378.4c0 .2 0 .5-.1.7-.2.9-.8 1.7-1.6 2.2H890c-.8-.5-1.4-1.2-1.6-2.2 0-.2-.1-.5-.1-.7 0-1.5 1-2.7 2.3-3.2v-.6c0-2.2 1.5-4.1 3.5-4.7.4-.1.9-.2 1.4-.2.9 0 1.8.3 2.6.7.7-.9 1.8-1.5 3.1-1.5 1.5 0 2.7.8 3.4 2 .2-.1.4-.1.7-.2h.6c1.4 0 2.6.6 3.4 1.6.7-.6 1.6-.9 2.6-.9 2.2 0 4 1.6 4.3 3.7h.2c.3-.1.6-.1 1-.1 1.6.1 3 1.6 3 3.4'
                  clipPath='url(#k)'
                  mask='url(#p)'></path>
                <linearGradient
                  id='q'
                  x1='904.35'
                  x2='904.35'
                  y1='698.681'
                  y2='710.901'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='1' stopColor='#9CD0F1'></stop>
                </linearGradient>
                <path
                  fill='url(#q)'
                  d='M920.4 378.4c0 .2 0 .5-.1.7-.2.9-.8 1.7-1.6 2.2H890c-.8-.5-1.4-1.2-1.6-2.2 0-.2-.1-.5-.1-.7 0-1.5 1-2.7 2.3-3.2v-.6c0-2.2 1.5-4.1 3.5-4.7.4-.1.9-.2 1.4-.2.9 0 1.8.3 2.6.7.7-.9 1.8-1.5 3.1-1.5 1.5 0 2.7.8 3.4 2 .2-.1.4-.1.7-.2h.6c1.4 0 2.6.6 3.4 1.6.7-.6 1.6-.9 2.6-.9 2.2 0 4 1.6 4.3 3.7h.2c.3-.1.6-.1 1-.1 1.6.1 3 1.6 3 3.4'
                  enableBackground='new'
                  opacity='0.5'></path>
                <g fill='#FFF' className='st77' opacity='0.25'>
                  <path
                    d='M894.1 373.9c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.1-.1.2 0 .2.2M891 379.3c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2M900.6 371c0 .1-.1.1-.1.1l-.1-.1c0-.1.1-.1.1-.1zM897.1 371.6c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1M907 373.2c-.1.1-.1 0 0 0-.1 0-.1-.1 0 0 0-.1 0 0 0 0M909.6 374.3q0 .15 0 0c-.1.1-.1 0 0 0q-.15 0 0 0M904.8 371.6s0 .1 0 0c-.1.1-.2 0-.2 0 0-.1.1-.1.2 0q0-.15 0 0M898.7 372.9c-.1.1-.1 0 0 0q-.15-.15 0 0 0-.15 0 0M889.1 377.9c-.1.1-.1 0 0 0q-.15-.15 0 0 0-.15 0 0M893.8 371.9s-.1 0 0 0c-.1.1-.1 0 0 0-.2-.1-.1-.1 0 0-.1-.1 0-.1 0 0M893.1 375.9q0 .15 0 0c-.1.1-.1 0 0 0M910.2 372.6c-.1.1-.1 0 0 0q-.15-.15 0 0 0-.15 0 0M913 374.5s0 .1 0 0c0 .1-.1 0 0 0-.1 0 0 0 0 0M914.1 373.2s0 .1 0 0c-.1.1-.2 0-.2 0 0-.1.1-.1.2 0q0-.15 0 0M914.4 375.8s0 .1 0 0c-.1.1-.1 0 0 0q-.15 0 0 0M917 375.7s-.1 0 0 0c-.1.1-.1 0 0 0-.2-.1-.1-.1 0 0-.1-.1 0-.1 0 0M917.2 378.2c-.1.1-.1 0 0 0q-.15-.15 0 0 0-.15 0 0M918.9 380q0 .15 0 0c-.1.1-.1 0 0 0q-.15 0 0 0M918.3 380.8c0 .1-.1.1 0 0q-.15.15 0 0-.15 0 0 0c-.1 0 0 0 0 0'
                    className='st30'></path>
                </g>
                <linearGradient
                  id='r'
                  x1='934.2'
                  x2='934.2'
                  y1='739.112'
                  y2='748.578'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path fill='url(#r)' d='M927.7 331.4h13v9.5h-13z'></path>
                <linearGradient
                  id='s'
                  x1='919.34'
                  x2='935.448'
                  y1='696.756'
                  y2='741.012'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path
                  fill='url(#s)'
                  d='m940.7 340.9-12.9 38.2-.7 2.2H914l.7-2.2.6-1.6.8-2.2 8.8-26.2.1-.4 2.2-6.4.2-.5.3-.9z'></path>
                <linearGradient
                  id='t'
                  x1='927.058'
                  x2='946.259'
                  y1='718.9'
                  y2='718.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path
                  fill='url(#t)'
                  d='M946.3 340.9v40.4h-19.2l.7-2.2 12.9-38.2z'></path>
                <linearGradient
                  id='u'
                  x1='940.736'
                  x2='946.275'
                  y1='743.85'
                  y2='743.85'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path fill='url(#u)' d='M940.7 331.4h5.5v9.5h-5.5z'></path>
                <linearGradient
                  id='v'
                  x1='981.619'
                  x2='987.159'
                  y1='743.85'
                  y2='743.85'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path fill='url(#v)' d='M981.6 331.4h5.5v9.5h-5.5z'></path>
                <g fill='#FFF'>
                  <path
                    d='m928.1 351.6-.4.9c1 .1 1.3 1 .7 2.7h1c.9-2.2.2-3.5-1.3-3.6m-4.7 3.6h1c.7-1.7 1.7-2.6 2.8-2.7l.4-.9c-1.6.1-3.3 1.4-4.2 3.6m4.8.5c-.7 1.5-1.6 2.3-2.6 2.4l-.4.9c1.5-.1 3.1-1.3 4-3.3zm-3.9 0h-1c-.6 2 0 3.2 1.5 3.3l.4-.9q-1.5-.15-.9-2.4M934.1 351.5c-1.1 0-2.3.4-3.1 1.1l.5.6c.7-.5 1.4-.8 2.2-.8 1 0 1.4.5 1.1 1.2-.2.4-.5.9-1.4 1.5h1.2c.7-.6 1-1.1 1.2-1.6.5-1.2-.1-2-1.7-2m-3.4 6.5 3.1-2.2c.1-.1.2-.1.3-.2h-1.3l-3.6 2.5-.3.7h5.3l.4-.9h-3.9z'
                    className='st30'></path>
                </g>
                <linearGradient
                  id='w'
                  x1='914.3'
                  x2='914.3'
                  y1='739.112'
                  y2='747.037'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path fill='url(#w)' d='M900.9 333h26.8v7.9h-26.8z'></path>
                <path
                  fill='#F2F7F7'
                  d='M927.4 339.1h-26c-.1 0-.3-.1-.3-.3v-5.2c0-.1.1-.3.3-.3h26c.1 0 .3.1.3.3v5.2q0 .3-.3.3'
                  className='st84'></path>
                <linearGradient
                  id='x'
                  x1='903.6'
                  x2='903.6'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#x)'
                  d='M905.7 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <linearGradient
                  id='y'
                  x1='908'
                  x2='908'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#y)'
                  d='M910.1 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <linearGradient
                  id='z'
                  x1='912.4'
                  x2='912.4'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#z)'
                  d='M914.5 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <linearGradient
                  id='A'
                  x1='916.8'
                  x2='916.8'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#A)'
                  d='M918.9 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <linearGradient
                  id='B'
                  x1='921.2'
                  x2='921.2'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#B)'
                  d='M923.3 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <linearGradient
                  id='C'
                  x1='925.6'
                  x2='925.6'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#C)'
                  d='M927.7 333.6v5.4h-4.1c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1z'></path>
                <linearGradient
                  id='D'
                  x1='901.7'
                  x2='901.7'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#D)'
                  d='M901.9 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1 0 0 0 0'></path>
                <linearGradient
                  id='E'
                  x1='910.5'
                  x2='910.5'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#E)'
                  d='M910.7 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1 0 0 0 0'></path>
                <linearGradient
                  id='F'
                  x1='914.6'
                  x2='914.6'
                  y1='741.049'
                  y2='743.423'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#F)'
                  d='m901.5 336.6 4.2.6v1.7c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1zm4.4.6v1.7c0 .1 0 .1.1.1h4c.1 0 .1 0 .1-.1v-1.5l-2.4.1zm4.4 1.7s0 .1 0 0l4.1.1c.1 0 .1 0 .1-.1v-1.7l-4.2.2zm4.4 0s0 .1 0 0l4.1.1c.1 0 .1 0 .1-.1V337l-4.2.2zm4.4-1.9v1.9c0 .1 0 .1.1.1h4c.1 0 .1 0 .1-.1V337h-4.2m4.4 0v1.9c0 .1 0 .1.1.1h4.1v-2z'
                  enableBackground='new'
                  opacity='0.25'></path>
                <g fill='#F2F7F7' className='st77' opacity='0.25'>
                  <path
                    d='m909.8 333.6-2.5 5.4h-1.2l2.6-5.4zM913.7 339l.8-1.7v1.6c0 .1 0 .1-.1.1zM918.9 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-2.1l1.5-3.2zc-.1-.1 0-.1 0 0M923.3 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0M926.2 333.6l-2.5 5.4h-.1c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1z'
                    className='st84'></path>
                </g>
                <linearGradient
                  id='G'
                  x1='919.3'
                  x2='919.3'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#G)'
                  d='M919.5 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1 0 0 0 0'></path>
                <linearGradient
                  id='H'
                  x1='923.7'
                  x2='923.7'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#H)'
                  d='M923.9 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1 0 0 0 0'></path>
                <linearGradient
                  id='I'
                  x1='906.15'
                  x2='906.15'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#I)'
                  d='M906.4 339h-.4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1-.1 0 0 0'></path>
                <linearGradient
                  id='J'
                  x1='914.9'
                  x2='914.9'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#J)'
                  d='M915.1 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1 0 0 0 0'></path>
                <linearGradient
                  id='K'
                  x1='955.4'
                  x2='955.4'
                  y1='739.112'
                  y2='747.037'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path fill='url(#K)' d='M942 333h26.8v7.9H942z'></path>
                <path
                  fill='#F2F7F7'
                  d='M968.6 339.1h-26c-.1 0-.3-.1-.3-.3v-5.2c0-.1.1-.3.3-.3h26c.1 0 .3.1.3.3v5.2q-.15.3-.3.3'
                  className='st84'></path>
                <linearGradient
                  id='L'
                  x1='944.7'
                  x2='944.7'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#L)'
                  d='M946.8 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zq0-.15 0 0'></path>
                <linearGradient
                  id='M'
                  x1='949.1'
                  x2='949.1'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#M)'
                  d='M951.2 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zq0-.15 0 0'></path>
                <linearGradient
                  id='N'
                  x1='953.5'
                  x2='953.5'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#N)'
                  d='M955.6 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zq0-.15 0 0'></path>
                <linearGradient
                  id='O'
                  x1='957.9'
                  x2='957.9'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#O)'
                  d='M960 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zq0-.15 0 0'></path>
                <linearGradient
                  id='P'
                  x1='962.3'
                  x2='962.3'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#P)'
                  d='M964.4 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zq0-.15 0 0'></path>
                <linearGradient
                  id='Q'
                  x1='966.7'
                  x2='966.7'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#Q)'
                  d='M968.8 333.6v5.4h-4.1c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1z'></path>
                <linearGradient
                  id='R'
                  x1='942.9'
                  x2='942.9'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#R)'
                  d='M943.1 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1-.1 0 0 0'></path>
                <linearGradient
                  id='S'
                  x1='951.7'
                  x2='951.7'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#S)'
                  d='M951.9 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1-.1 0 0 0'></path>
                <linearGradient
                  id='T'
                  x1='955.7'
                  x2='955.7'
                  y1='741.049'
                  y2='743.423'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#T)'
                  d='m942.6 336.6 4.2.6v1.7c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1zm4.4.6v1.7c0 .1 0 .1.1.1h4c.1 0 .1 0 .1-.1v-1.5l-2.4.1zm4.4 1.7s.1.1 0 0l4.1.1c.1 0 .1 0 .1-.1v-1.7l-4.2.2zm4.4 0s.1.1 0 0l4.1.1c.1 0 .1 0 .1-.1V337l-4.2.2zm4.4-1.9v1.9c0 .1 0 .1.1.1h4c.1 0 .1 0 .1-.1V337h-4.2m4.4 0v1.9c0 .1 0 .1.1.1h4.1v-2z'
                  enableBackground='new'
                  opacity='0.25'></path>
                <g fill='#F2F7F7' className='st77' opacity='0.25'>
                  <path
                    d='m951 333.6-2.5 5.4h-1.2l2.5-5.4zM954.8 339l.8-1.7v1.6c0 .1 0 .1-.1.1zM960 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-2.1l1.5-3.2zq0-.15 0 0M964.4 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zq0-.15 0 0M967.3 333.6l-2.5 5.4h-.1c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1z'
                    className='st84'></path>
                </g>
                <linearGradient
                  id='U'
                  x1='960.5'
                  x2='960.5'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#U)'
                  d='M960.7 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1-.1 0 0 0'></path>
                <linearGradient
                  id='V'
                  x1='964.9'
                  x2='964.9'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#V)'
                  d='M965.1 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1-.1 0 0 0'></path>
                <linearGradient
                  id='W'
                  x1='947.3'
                  x2='947.3'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#W)'
                  d='M947.5 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1-.1 0 0 0'></path>
                <linearGradient
                  id='X'
                  x1='956.1'
                  x2='956.1'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#X)'
                  d='M956.3 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1-.1 0 0 0'></path>
                <path
                  fill='#F2F7F7'
                  d='M898.3 338.3h-10.5c-.3 0-.5-.2-.5-.5v-3.7c0-.3.2-.5.5-.5h10.5c.3 0 .5.2.5.5v3.7c0 .3-.2.5-.5.5'
                  className='st84'></path>
                <linearGradient
                  id='Y'
                  x1='887.509'
                  x2='898.641'
                  y1='744'
                  y2='744'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#Y)'
                  d='M898.6 333.9v4.2s0 .1-.1.1h-11s-.1 0-.1-.1v-4.2s0-.1.1-.1zq0-.15 0 0'></path>
                <g fill='#F2F7F7' className='st77' opacity='0.25'>
                  <path
                    d='m891.1 333.8-1.4 4.3h-1.2l1.4-4.3zM897.9 333.8l-1.4 4.3h-3l1.4-4.3z'
                    className='st84'></path>
                </g>
                <path
                  fill='#A7C1D5'
                  d='M898.6 335.9v2.2s0 .1-.1.1h-11s-.1 0-.1-.1v-1.4h6.8z'
                  className='st113'
                  opacity='0.25'></path>
                <linearGradient
                  id='Z'
                  x1='887.7'
                  x2='887.7'
                  y1='741.861'
                  y2='746.209'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#Z)'
                  d='M887.9 338.1h-.3c-.1 0-.1 0-.1-.1v-4.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1z'></path>
                <path
                  fill='#F2F7F7'
                  d='M939.5 338.3H929c-.3 0-.5-.2-.5-.5v-3.7c0-.3.2-.5.5-.5h10.5c.3 0 .5.2.5.5v3.7c0 .3-.3.5-.5.5'
                  className='st84'></path>
                <linearGradient
                  id='aa'
                  x1='928.645'
                  x2='939.777'
                  y1='744'
                  y2='744'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#aa)'
                  d='M939.8 333.9v4.2s0 .1-.1.1h-11s-.1 0-.1-.1v-4.2s0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <g fill='#F2F7F7' className='st77' opacity='0.25'>
                  <path
                    d='m932.2 333.8-1.4 4.3h-1.1l1.4-4.3zM939 333.8l-1.4 4.3h-2.9l1.4-4.3z'
                    className='st84'></path>
                </g>
                <path
                  fill='#A7C1D5'
                  d='M939.8 335.9v2.2s0 .1-.1.1h-11s-.1 0-.1-.1v-1.4h6.8z'
                  className='st113'
                  opacity='0.25'></path>
                <linearGradient
                  id='ab'
                  x1='928.9'
                  x2='928.9'
                  y1='741.861'
                  y2='746.209'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#ab)'
                  d='M929.1 338.1h-.3c-.1 0-.1 0-.1-.1v-4.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zq-.15 0 0 0'></path>
                <linearGradient
                  id='ac'
                  x1='957.7'
                  x2='957.7'
                  y1='732.844'
                  y2='739.112'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path
                  fill='url(#ac)'
                  d='m969.1 340.9-.3.9h-16.3c-1.4 0-2.6 1.2-2.6 2.6v1.3c-1.3.3-2.5.8-3.6 1.4v-6.3h22.8z'></path>
                <path
                  fill='#40536C'
                  d='m968.8 341.8-2.4 6.9h-16.5v-4.3c0-1.4 1.2-2.6 2.6-2.6z'
                  className='st62'></path>
                <path
                  fill='#40536C'
                  d='m968.5 341.8-.1.4-2.2 6.4h-12.7v-4.3c0-1.4 1.2-2.6 2.6-2.6h12.4z'
                  className='st62'></path>
                <path
                  fill='#475D76'
                  d='m968.4 342.3-2.3 6.9h-9.5v-4.3c0-1.4 1.2-2.6 2.6-2.6z'
                  className='st63'></path>
                <linearGradient
                  id='ad'
                  x1='950.35'
                  x2='950.35'
                  y1='698.7'
                  y2='734.646'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#79AACE'></stop>
                  <stop offset='0.584' stopColor='#95C9ED'></stop>
                  <stop offset='0.763' stopColor='#C9E5F8'></stop>
                  <stop offset='0.863' stopColor='#AEDAF5'></stop>
                  <stop offset='1' stopColor='#9CD0F1'></stop>
                </linearGradient>
                <path
                  fill='url(#ad)'
                  d='m967.5 345.4-12.3 35.9h-22c0-8.1 4.8-19.1 7.2-26.8 1-3.2 3.1-5.8 5.9-7.4 1.1-.7 2.3-1.1 3.6-1.4q1.5-.3 3-.3z'></path>
                <linearGradient
                  id='ae'
                  x1='933.2'
                  x2='967.549'
                  y1='716.65'
                  y2='716.65'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='0.198' stopColor='#FAFBFD'></stop>
                  <stop offset='0.338' stopColor='#EFF1F8'></stop>
                  <stop offset='0.459' stopColor='#DFE4F1'></stop>
                  <stop offset='0.57' stopColor='#C9D2E7'></stop>
                  <stop offset='0.675' stopColor='#AEBEDC'></stop>
                  <stop offset='0.774' stopColor='#8FA6D0'></stop>
                  <stop offset='0.869' stopColor='#6B8FC2'></stop>
                  <stop offset='0.958' stopColor='#3D78B4'></stop>
                  <stop offset='1' stopColor='#166EAE'></stop>
                </linearGradient>
                <path
                  fill='url(#ae)'
                  d='m967.5 345.4-12.3 35.9h-22c0-8.1 4.8-19.1 7.2-26.8 1-3.2 3.1-5.8 5.9-7.4 1.1-.7 2.3-1.1 3.6-1.4q1.5-.3 3-.3z'
                  enableBackground='new'
                  opacity='0.4'></path>
                <g className='st66' opacity='0.5'>
                  <path
                    fill='#EAF4FC'
                    d='M935.1 378.4c.3-2.6.8-5.1 1.3-7.6h.1v.1c-.5 2.4-.9 4.9-1.4 7.5q.15 0 0 0M953.8 378.4s-.1 0 0 0c.3-2.6.8-5.1 1.3-7.6h.1v.1c-.5 2.4-1 4.9-1.4 7.5M937.7 365.8s-.1 0 0 0c.6-2.6 1.4-5.1 2.3-8h.1v.1c-.9 2.8-1.7 5.4-2.4 7.9M956.7 365.8c.6-2.6 1.4-5.1 2.3-8h.1v.1c-.9 2.8-1.6 5.4-2.4 7.9q.15 0 0 0M941.4 354.1q-.15-.15 0 0l.2-.7c.7-2.1 2.1-3.8 4.1-5.1.9-.6 2-1 3.1-1.3s2.2-.5 3.4-.5c0 0 .1 0 .1.1 0 0 0 .1-.1.1-4.9 0-9.1 2.7-10.5 6.8zc0-.1 0 0 0 0M959.8 354.1q0-.15 0 0l.2-.7c.9-2.6 2.9-4.6 5.6-5.8h.1v.1c-2.7 1.2-4.7 3.2-5.6 5.8zc.1-.1.1 0 0 0M944.6 378.4c0-.1.4-2.3 1-5.4h.1v.1c-.6 3-1 5.2-1.1 5.3q.15 0 0 0M947 366.2q-.15 0 0 0c1-5.3 1.8-9.1 2.3-11.5h.1v.1c-.6 2.3-1.3 6.2-2.4 11.4M952.5 349.2q-.15 0 0 0-.15-.15 0 0c1.3-1.1 2.7-1.6 3.7-1.9 1.1-.3 1.8-.4 1.8-.4h.1v.1s-.8.1-1.8.4c-1.1.2-2.5.8-3.8 1.8'
                    className='st67'></path>
                  <path
                    fill='#537898'
                    d='M948.3 379.7s-.1 0 0 0c.1-1.2.9-4.7 2.3-10.6h.1v.1c-1.4 5.8-2.2 9.4-2.4 10.5M952.3 362.3q-.15 0 0 0c-.1 0-.1-.1 0 0 .3-1.5.6-3 1-4.6h.1v.1c-.4 1.5-.8 3-1.1 4.5M954.4 353.4q-.15 0 0 0c.4-1.4 1-2.6 1.8-3.5.7-.8 1.4-1.4 2.3-1.9 1.5-.8 2.7-.9 2.8-.9h.1v.1s-1.3.1-2.7.9c-1.5.7-3.3 2.3-4.3 5.3M940.1 379.7q-.15 0 0 0c0-.6.3-1.7.5-3.2h.1v.1c-.3 1.4-.5 2.5-.6 3.1M941.7 371.4s-.1 0 0 0c.3-1.6.6-3.1.9-4.6h.1v.1c-.3 1.4-.6 3-1 4.5'
                    className='st60'
                    opacity='0.4'></path>
                </g>
                <linearGradient
                  id='af'
                  x1='945.3'
                  x2='945.3'
                  y1='698.681'
                  y2='706.526'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#B8DDF5'></stop>
                  <stop offset='0.601' stopColor='#D8EDFA'></stop>
                  <stop offset='1' stopColor='#E7F6FD'></stop>
                </linearGradient>
                <path
                  fill='url(#af)'
                  d='M958.8 381v.3h-26.2c-.5-.5-.8-1.2-.8-2.1v-.1c.1-1.4 1-2.5 2.2-2.5.4 0 .8.1 1.1.3.1-.1.1-.3.2-.4.5-.7 1.2-1.4 2.2-1.8 1.5-.7 3.1-.7 4 0 .3-.5.8-1 1.4-1.1 1-.3 2.1.2 2.8 1.1.1-.2.3-.4.5-.5.3-.2.8-.2 1.3-.2 1 0 1.9.7 2.2 1.7.4.1.8.2 1.1.4.2-.6.9-1.1 1.6-1.1.9 0 1.7.7 1.7 1.7 0 .2 0 .4-.1.6.3-.1.6-.1.9-.1.5 0 1 .1 1.4.4.7.4 1.4 1 1.8 1.6.5.5.7 1.2.7 1.8'></path>
                <path
                  fill='#CBE5F7'
                  d='M934.4 381.3h-.5c-.1-.3-.2-.6-.2-.9 0-.4 0-.9.2-1.3.1-.3.3-.5.5-.7-.1.2-.2.5-.3.7-.1.3-.1.6-.1.9s.1.6.3.9c0 .2.1.3.1.4M949.8 375.7c-.3-.1-.5-.1-.8-.1-.9 0-1.8.3-2.5.9 0-.1 0-.2-.1-.3.6-.4 1.4-.7 2.2-.7.4 0 .8.1 1.2.2M952.8 377.9l-.2.2c-.2-.4-.4-.8-.7-1.2-.2-.2-.5-.5-.8-.6-.1-.1-.2-.1-.3-.2l.6.3c.3.2.5.4.8.6q.45.45.6.9M951.9 379.1c-.2.4-.3.8-.3 1.3 0 .2 0 .5.1.7 0 .1 0 .1.1.2h-5.6q.3-.45.3-.9c0-.5-.3-1-.7-1.3.1 0 .1.1.2.1.5.3.8.8.8 1.4 0 .3.2.5.5.5h4.2v-.3c-.1-.6.1-1.2.4-1.7 0-.1.1-.2.1-.2 0 .1-.1.2-.1.2M944 379.7v.2c0 .5-.2 1-.4 1.4h-5.4q-.3-.6-.3-1.5c0-.3 0-.5.1-.7l.3-.9c.1-.1.1-.2.2-.3s.1-.2.2-.3c-.1.1-.1.2-.2.3-.2.4-.3.8-.4 1.2v.5c0 .7.6 1.3 1.4 1.3h3.9c.2-.4.3-.8.3-1.3v-.8c-.1-.8-.6-1.4-1.1-1.9-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1c.2 0 .3.1.5.2.1-.4 0-.9-.1-1.2-.2-.3-.4-.6-.7-.8.4.2.8.5 1 1 .2.4.2.8.1 1.3.7.4 1.2 1.1 1.4 1.9v.30000000000000004c-.1.1-.1.3-.1.5M936.1 377.9c-.4-.8-1.1-1-1.1-1 .1-.1.1-.3.2-.4.5.3 1 .9.9 1.4'
                  className='st69'></path>
                <defs>
                  <path d='M1 1h1L1 2z'></path>
                </defs>
                <defs>
                  <path d='M-1-1h-1l1-1z'></path>
                </defs>
                <clipPath id='ag'>
                  <path d='M1 1h1L1 2z' overflow='visible'></path>
                </clipPath>
                <clipPath id='ai' clipPath='url(#ag)'>
                  <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                </clipPath>
                <defs>
                  <filter
                    id='ah'
                    width='32.2'
                    height='12.4'
                    x='929.4'
                    y='368.9'
                    filterUnits='userSpaceOnUse'>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'></feColorMatrix>
                  </filter>
                </defs>
                <mask
                  id='an'
                  width='32.2'
                  height='12.4'
                  x='929.4'
                  y='368.9'
                  maskUnits='userSpaceOnUse'>
                  <g filter='url(#ah)'>
                    <defs>
                      <path d='M1 1h1L1 2z'></path>
                    </defs>
                    <defs>
                      <path d='M-1-1h-1l1-1z'></path>
                    </defs>
                    <clipPath id='aj' clipPath='url(#ai)'>
                      <path d='M1 1h1L1 2z' overflow='visible'></path>
                    </clipPath>
                    <clipPath id='al' clipPath='url(#aj)'>
                      <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                    </clipPath>
                    <linearGradient
                      id='ak'
                      x1='945.5'
                      x2='945.5'
                      y1='698.681'
                      y2='710.901'
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'>
                      <stop offset='0' stopColor='#FFF'></stop>
                      <stop offset='1'></stop>
                    </linearGradient>
                    <path
                      fill='url(#ak)'
                      d='M961.6 378.4c0 .2 0 .5-.1.7-.2.9-.8 1.7-1.6 2.2h-28.8c-.8-.5-1.4-1.2-1.6-2.2 0-.2-.1-.5-.1-.7 0-1.5 1-2.7 2.3-3.2v-.6c0-2.7 2.2-4.9 4.9-4.9.9 0 1.8.3 2.6.7.7-.9 1.8-1.5 3.1-1.5 1.5 0 2.7.8 3.4 2 .2-.1.4-.1.7-.2h.6c1.4 0 2.6.6 3.4 1.6.7-.6 1.6-.9 2.6-.9 2.2 0 4 1.6 4.3 3.7.3-.1.7-.2 1.1-.2 1.7.2 3.2 1.7 3.2 3.5'
                      clipPath='url(#al)'></path>
                  </g>
                </mask>
                <linearGradient
                  id='am'
                  x1='945.5'
                  x2='945.5'
                  y1='698.681'
                  y2='710.901'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='1'></stop>
                </linearGradient>
                <path
                  fill='url(#am)'
                  d='M961.6 378.4c0 .2 0 .5-.1.7-.2.9-.8 1.7-1.6 2.2h-28.8c-.8-.5-1.4-1.2-1.6-2.2 0-.2-.1-.5-.1-.7 0-1.5 1-2.7 2.3-3.2v-.6c0-2.7 2.2-4.9 4.9-4.9.9 0 1.8.3 2.6.7.7-.9 1.8-1.5 3.1-1.5 1.5 0 2.7.8 3.4 2 .2-.1.4-.1.7-.2h.6c1.4 0 2.6.6 3.4 1.6.7-.6 1.6-.9 2.6-.9 2.2 0 4 1.6 4.3 3.7.3-.1.7-.2 1.1-.2 1.7.2 3.2 1.7 3.2 3.5'
                  clipPath='url(#ai)'
                  mask='url(#an)'></path>
                <linearGradient
                  id='ao'
                  x1='945.5'
                  x2='945.5'
                  y1='698.681'
                  y2='710.901'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='1' stopColor='#9CD0F1'></stop>
                </linearGradient>
                <path
                  fill='url(#ao)'
                  d='M961.6 378.4c0 .2 0 .5-.1.7-.2.9-.8 1.7-1.6 2.2h-28.8c-.8-.5-1.4-1.2-1.6-2.2 0-.2-.1-.5-.1-.7 0-1.5 1-2.7 2.3-3.2v-.6c0-2.7 2.2-4.9 4.9-4.9.9 0 1.8.3 2.6.7.7-.9 1.8-1.5 3.1-1.5 1.5 0 2.7.8 3.4 2 .2-.1.4-.1.7-.2h.6c1.4 0 2.6.6 3.4 1.6.7-.6 1.6-.9 2.6-.9 2.2 0 4 1.6 4.3 3.7.3-.1.7-.2 1.1-.2 1.7.2 3.2 1.7 3.2 3.5'
                  enableBackground='new'
                  opacity='0.5'></path>
                <g fill='#FFF' className='st77' opacity='0.25'>
                  <path
                    d='M935.3 373.9c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.1-.1.2 0 .2.2M932.2 379.3c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2M941.7 371c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1l.1-.1c.1 0 .1.1.1.1M938.2 371.6c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1M948.2 373.2s-.1 0 0 0c-.1.1-.1 0 0 0-.2 0-.1-.1 0 0-.1-.1 0 0 0 0M950.7 374.3q0 .15 0 0c-.1.1-.1 0 0 0q-.15 0 0 0M945.9 371.6s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0q0-.15 0 0M939.8 372.9c-.1.1-.1 0 0 0q-.15-.15 0 0 0-.15 0 0M930.3 377.9s-.1 0 0 0c-.1.1-.1 0 0 0-.2-.1-.1-.1 0 0-.1-.1 0-.1 0 0M934.9 371.9c-.1.1-.1 0 0 0q-.15-.15 0 0 0-.15 0 0M934.3 375.9q0 .15 0 0c-.1.1-.1 0 0 0q-.15 0 0 0M951.4 372.6s-.1 0 0 0c-.1.1-.1 0 0 0-.1 0-.1-.1 0 0-.1-.1 0-.1 0 0M954.2 374.5s-.1.1 0 0c-.1.1-.1 0 0 0q-.15 0 0 0c-.1 0 0 0 0 0M955.2 373.2s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0q0-.15 0 0M953.7 372.3q-.15 0 0 0c-.1 0-.1-.1 0 0 0-.1 0 0 0 0M955.5 375.8s0 .1 0 0c0 .1-.1 0 0 0-.1 0 0 0 0 0'
                    className='st30'></path>
                  <circle cx='958' cy='375.7' r='0.1' className='st30'></circle>
                  <path
                    d='M958.3 378.2c-.1.1-.1 0 0 0q-.15-.15 0 0 0-.15 0 0M960 380q0 .15 0 0c-.1.1-.1 0 0 0M959.4 380.8q0 .15 0 0-.15.15 0 0-.15 0 0 0'
                    className='st30'></path>
                </g>
                <linearGradient
                  id='ap'
                  x1='960.196'
                  x2='976.304'
                  y1='696.772'
                  y2='741.028'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path fill='url(#ap)' d='M967.9 381.3h-13l13.7-40.4h13z'></path>
                <linearGradient
                  id='aq'
                  x1='967.942'
                  x2='987.159'
                  y1='718.9'
                  y2='718.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path
                  fill='url(#aq)'
                  d='M987.2 340.9v40.4h-19.3l.8-2.2 12.9-38.2z'></path>
                <g fill='#FFF'>
                  <path
                    d='M965.2 355.6h-1c-.6 2 0 3.2 1.5 3.3l.4-.9q-1.5-.3-.9-2.4m3.9 0c-.7 1.5-1.6 2.3-2.6 2.4l-.4.9c1.5-.1 3.1-1.3 4-3.3zm-4.7-.5h1c.7-1.7 1.7-2.6 2.8-2.7l.4-.9c-1.7 0-3.3 1.4-4.2 3.6m4.6-3.7-.4.9c1 .1 1.3 1 .7 2.7h1c.9-2.2.2-3.5-1.3-3.6M975.7 355.6h-1.5l-.1.2c.5.1.7.4.5.9-.3.8-1.1 1.3-2.2 1.3-.9 0-1.6-.3-1.9-.8l-.8.8c.4.6 1.3.9 2.3.9 1.9 0 3.2-1 3.6-2.2.2-.5.3-.9.1-1.1m-3.3-3.8-.4.9h3.5l-2.7 2.3v.1h1.1l.3-.2.2-.1 2.6-2.2.3-.7z'
                    className='st30'></path>
                </g>
                <linearGradient
                  id='ar'
                  x1='968.57'
                  x2='981.619'
                  y1='743.85'
                  y2='743.85'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path fill='url(#ar)' d='M968.6 331.4h13v9.5h-13z'></path>
                <path
                  fill='#F2F7F7'
                  d='M980.3 338.3h-10.5c-.3 0-.5-.2-.5-.5v-3.7c0-.3.2-.5.5-.5h10.5c.3 0 .5.2.5.5v3.7c.1.3-.2.5-.5.5'
                  className='st84'></path>
                <linearGradient
                  id='as'
                  x1='969.529'
                  x2='980.661'
                  y1='744'
                  y2='744'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#as)'
                  d='M980.7 333.9v4.2s0 .1-.1.1h-11s-.1 0-.1-.1v-4.2s0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <g fill='#F2F7F7' className='st77' opacity='0.25'>
                  <path
                    d='m973.1 333.8-1.4 4.3h-1.2l1.5-4.3zM979.9 333.8l-1.4 4.3h-3l1.4-4.3z'
                    className='st84'></path>
                </g>
                <path
                  fill='#A7C1D5'
                  d='M980.7 335.9v2.2s0 .1-.1.1h-11s-.1 0-.1-.1v-1.4h6.8z'
                  className='st113'
                  opacity='0.25'></path>
                <linearGradient
                  id='at'
                  x1='969.8'
                  x2='969.8'
                  y1='741.861'
                  y2='746.209'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#at)'
                  d='M970 338.1h-.3c-.1 0-.1 0-.1-.1v-4.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zq-.15 0 0 0'></path>
                <linearGradient
                  id='au'
                  x1='996.3'
                  x2='996.3'
                  y1='739.112'
                  y2='747.037'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path fill='url(#au)' d='M982.9 333h26.8v7.9h-26.8z'></path>
                <path
                  fill='#F2F7F7'
                  d='M1009.5 339.1h-26c-.1 0-.3-.1-.3-.3v-5.2c0-.1.1-.3.3-.3h26c.1 0 .3.1.3.3v5.2c0 .2-.2.3-.3.3'
                  className='st84'></path>
                <linearGradient
                  id='av'
                  x1='985.7'
                  x2='985.7'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#av)'
                  d='M987.8 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <linearGradient
                  id='aw'
                  x1='990.1'
                  x2='990.1'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#aw)'
                  d='M992.2 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <linearGradient
                  id='ax'
                  x1='994.5'
                  x2='994.5'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#ax)'
                  d='M996.6 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <linearGradient
                  id='ay'
                  x1='998.9'
                  x2='998.9'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#ay)'
                  d='M1001 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <linearGradient
                  id='az'
                  x1='1003.3'
                  x2='1003.3'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#az)'
                  d='M1005.4 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0'></path>
                <linearGradient
                  id='aA'
                  x1='1007.7'
                  x2='1007.7'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#aA)'
                  d='M1009.8 333.6v5.4h-4.1c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1z'></path>
                <linearGradient
                  id='aB'
                  x1='983.8'
                  x2='983.8'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#aB)'
                  d='M984 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1 0 0 0 0'></path>
                <linearGradient
                  id='aC'
                  x1='992.6'
                  x2='992.6'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#aC)'
                  d='M992.8 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1 0 0 0 0'></path>
                <linearGradient
                  id='aD'
                  x1='996.7'
                  x2='996.7'
                  y1='741.049'
                  y2='743.423'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#aD)'
                  d='m983.6 336.6 4.2.6v1.7c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1zm4.4.6v1.7c0 .1 0 .1.1.1h4c.1 0 .1 0 .1-.1v-1.5l-2.4.1zm4.4 1.7s0 .1 0 0l4.1.1c.1 0 .1 0 .1-.1v-1.7l-4.2.2zm4.4 0s0 .1 0 0l4.1.1c.1 0 .1 0 .1-.1V337l-4.2.2zm4.4-1.9v1.9c0 .1 0 .1.1.1h4c.1 0 .1 0 .1-.1V337h-4.2m4.4 0v1.9c0 .1 0 .1.1.1h4.1v-2z'
                  enableBackground='new'
                  opacity='0.25'></path>
                <g fill='#F2F7F7' className='st77' opacity='0.25'>
                  <path
                    d='m991.9 333.6-2.5 5.4h-1.2l2.5-5.4zM995.7 339l.8-1.7v1.6c0 .1 0 .1-.1.1zM1001 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-2.1l1.5-3.2zc-.1-.1 0-.1 0 0M1005.4 333.7v5.2c0 .1 0 .1-.1.1h-4c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1zc-.1-.1 0-.1 0 0M1008.3 333.6l-2.5 5.4h-.1c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1z'
                    className='st84'></path>
                </g>
                <linearGradient
                  id='aE'
                  x1='1001.4'
                  x2='1001.4'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#aE)'
                  d='M1001.6 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1 0 0 0 0'></path>
                <linearGradient
                  id='aF'
                  x1='1005.8'
                  x2='1005.8'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#aF)'
                  d='M1006 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1 0 0 0 0'></path>
                <linearGradient
                  id='aG'
                  x1='988.2'
                  x2='988.2'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#aG)'
                  d='M988.4 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1 0 0 0 0'></path>
                <linearGradient
                  id='aH'
                  x1='997'
                  x2='997'
                  y1='741.049'
                  y2='746.413'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#aH)'
                  d='M997.2 339h-.3c-.1 0-.1 0-.1-.1v-5.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1zc-.1-.1 0 0 0 0'></path>
                <linearGradient
                  id='aI'
                  x1='998.6'
                  x2='998.6'
                  y1='732.844'
                  y2='739.112'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='0.218' stopColor='#9FB4B9'></stop>
                  <stop offset='0.495' stopColor='#ADC0C3'></stop>
                  <stop offset='0.802' stopColor='#C4D5D6'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path
                  fill='url(#aI)'
                  d='m1010 340.9-.3.9h-16.3c-1.4 0-2.6 1.2-2.6 2.6v1.3c-1.3.3-2.5.8-3.6 1.4v-6.3h22.8z'></path>
                <path
                  fill='#40536C'
                  d='m1009.7 341.8-2.4 6.9h-16.5v-4.3c0-1.4 1.2-2.6 2.6-2.6z'
                  className='st62'></path>
                <path
                  fill='#40536C'
                  d='m1009.4 341.8-.1.4-2.2 6.4h-12.7v-4.3c0-1.4 1.2-2.6 2.6-2.6h12.4z'
                  className='st62'></path>
                <path
                  fill='#475D76'
                  d='m1009.2 342.3-2.3 6.9h-9.5v-4.3c0-1.4 1.2-2.6 2.6-2.6z'
                  className='st63'></path>
                <linearGradient
                  id='aJ'
                  x1='991.25'
                  x2='991.25'
                  y1='698.7'
                  y2='734.646'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#79AACE'></stop>
                  <stop offset='0.584' stopColor='#95C9ED'></stop>
                  <stop offset='0.763' stopColor='#C9E5F8'></stop>
                  <stop offset='0.863' stopColor='#AEDAF5'></stop>
                  <stop offset='1' stopColor='#9CD0F1'></stop>
                </linearGradient>
                <path
                  fill='url(#aJ)'
                  d='m1008.4 345.4-12.3 35.9h-22c0-8.1 4.8-19.1 7.2-26.8 1-3.2 3.1-5.8 5.9-7.4 1.1-.7 2.3-1.1 3.6-1.4q1.5-.3 3-.3z'></path>
                <linearGradient
                  id='aK'
                  x1='974.05'
                  x2='1008.399'
                  y1='716.65'
                  y2='716.65'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='0.198' stopColor='#FAFBFD'></stop>
                  <stop offset='0.338' stopColor='#EFF1F8'></stop>
                  <stop offset='0.459' stopColor='#DFE4F1'></stop>
                  <stop offset='0.57' stopColor='#C9D2E7'></stop>
                  <stop offset='0.675' stopColor='#AEBEDC'></stop>
                  <stop offset='0.774' stopColor='#8FA6D0'></stop>
                  <stop offset='0.869' stopColor='#6B8FC2'></stop>
                  <stop offset='0.958' stopColor='#3D78B4'></stop>
                  <stop offset='1' stopColor='#166EAE'></stop>
                </linearGradient>
                <path
                  fill='url(#aK)'
                  d='m1008.4 345.4-12.3 35.9h-22c0-8.1 4.8-19.1 7.2-26.8 1-3.2 3.1-5.8 5.9-7.4 1.1-.7 2.3-1.1 3.6-1.4q1.5-.3 3-.3z'
                  enableBackground='new'
                  opacity='0.4'></path>
                <g className='st66' opacity='0.5'>
                  <path
                    fill='#EAF4FC'
                    d='M976 378.4c.3-2.6.8-5.1 1.3-7.6h.1v.1c-.5 2.4-1 4.9-1.4 7.5q.15 0 0 0M994.7 378.4q-.15 0 0 0c.3-2.6.8-5.1 1.3-7.6h.1v.1c-.6 2.4-1 4.9-1.4 7.5M978.6 365.8q-.15 0 0 0c.6-2.6 1.4-5.1 2.3-8h.1v.1c-.9 2.8-1.7 5.4-2.4 7.9M997.6 365.8c.6-2.6 1.4-5.1 2.3-8h.1v.1c-.9 2.8-1.7 5.4-2.4 7.9.1 0 0 0 0 0M982.3 354.1s-.1 0 0 0q-.15-.15 0 0l.2-.7c.7-2.1 2.1-3.8 4.1-5.1.9-.6 2-1 3.1-1.3s2.2-.5 3.4-.5c0 0 .1 0 .1.1 0 0 0 .1-.1.1-4.9 0-9.1 2.7-10.5 6.8zc0-.1 0 0 0 0M1000.7 354.1q0-.15 0 0l.2-.7c.9-2.6 2.9-4.6 5.6-5.8h.1v.1c-2.7 1.2-4.7 3.2-5.6 5.8zc.1-.1 0 0 0 0M985.5 378.4c0-.1.4-2.3 1-5.4h.1v.1c-.6 3-1 5.2-1.1 5.3.1 0 0 0 0 0M987.9 366.2q-.15 0 0 0c1-5.3 1.8-9.1 2.3-11.5h.1v.1c-.6 2.3-1.4 6.2-2.4 11.4M993.3 349.2q0-.15 0 0c1.3-1.1 2.7-1.6 3.7-1.9 1.1-.3 1.8-.4 1.8-.4h.1v.1s-.8.1-1.8.4c-1 .2-2.5.8-3.8 1.8q.15 0 0 0'
                    className='st67'></path>
                  <path
                    fill='#537898'
                    d='M989.2 379.7q-.15 0 0 0c.1-1.2.9-4.7 2.3-10.6h.1v.1c-1.4 5.8-2.2 9.4-2.4 10.5M993.1 362.3s0-.1 0 0c.3-1.5.6-3 1-4.6h.1v.1c-.3 1.5-.7 3-1.1 4.5q.15 0 0 0M995.3 353.4q-.15 0 0 0c.4-1.4 1-2.6 1.8-3.5.7-.8 1.4-1.4 2.3-1.9 1.5-.8 2.7-.9 2.8-.9h.1v.1s-1.3.1-2.7.9c-1.5.7-3.3 2.3-4.3 5.3M980.9 379.7c0-.6.3-1.7.5-3.2h.1v.1c-.2 1.4-.4 2.5-.6 3.1q.15 0 0 0M982.6 371.4q-.15 0 0 0c.3-1.6.6-3.1.9-4.6h.1v.1c-.3 1.4-.7 3-1 4.5'
                    className='st60'
                    opacity='0.4'></path>
                </g>
                <linearGradient
                  id='aL'
                  x1='984.75'
                  x2='984.75'
                  y1='698.681'
                  y2='706.526'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#B8DDF5'></stop>
                  <stop offset='0.601' stopColor='#D8EDFA'></stop>
                  <stop offset='1' stopColor='#E7F6FD'></stop>
                </linearGradient>
                <path
                  fill='url(#aL)'
                  d='m996.8 379.1-.7 2.2h-22.6c-.5-.5-.8-1.2-.8-2.1v-.1c.1-1.4 1-2.5 2.2-2.5.4 0 .8.1 1.1.3.1-.1.1-.3.2-.4.5-.7 1.2-1.4 2.2-1.8 1.5-.7 3.1-.7 4 0 .3-.5.8-1 1.4-1.1 1-.3 2.1.2 2.8 1.1.1-.2.3-.4.5-.5v4.9z'></path>
                <path
                  fill='#CBE5F7'
                  d='M975.3 381.3h-.5c-.1-.3-.2-.6-.2-.9 0-.4 0-.9.2-1.3.1-.3.3-.5.5-.7-.1.2-.2.5-.3.7-.1.3-.1.6-.1.9s.1.6.3.9c0 .2 0 .3.1.4M990.7 375.7c-.3-.1-.5-.1-.8-.1-.9 0-1.8.3-2.5.9 0-.1 0-.2-.1-.3.6-.4 1.4-.7 2.2-.7.4 0 .8.1 1.2.2M993.7 377.9l-.2.2c-.2-.4-.4-.8-.7-1.2-.2-.2-.5-.5-.8-.6-.1-.1-.2-.1-.3-.2l.6.3c.3.2.5.4.8.6q.45.45.6.9M992.8 379.1c-.2.4-.3.8-.3 1.3 0 .2 0 .5.1.7 0 .1 0 .1.1.2H987q.3-.45.3-.9c0-.5-.3-1-.7-1.3.1 0 .1.1.2.1.5.3.8.8.8 1.4 0 .3.2.5.5.5h4.2v-.3c0-.6.1-1.2.5-1.7 0-.1.1-.2.1-.2-.1.1-.1.2-.1.2M984.9 379.7v.2c0 .5-.2 1-.4 1.4H979q-.3-.6-.3-1.5c0-.3 0-.5.1-.7l.3-.9c.1-.1.1-.2.2-.3s.1-.2.2-.3c-.1.1-.1.2-.2.3-.2.4-.3.8-.4 1.2v.5c0 .7.6 1.3 1.4 1.3h3.9c.2-.4.3-.8.3-1.3v-.8c-.1-.8-.6-1.4-1.1-1.9-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1c.2 0 .3.1.5.2.1-.4 0-.9-.1-1.2-.2-.3-.4-.6-.7-.8.4.2.8.5 1 1 .2.4.2.8.1 1.3.7.4 1.2 1.1 1.4 1.9v.8M977 377.9c-.4-.8-1.1-1-1.1-1 .1-.1.1-.3.2-.4.5.3.9.9.9 1.4'
                  className='st69'></path>
                <defs>
                  <path d='M1 1h1L1 2z'></path>
                </defs>
                <defs>
                  <path d='M-1-1h-1l1-1z'></path>
                </defs>
                <clipPath id='aM'>
                  <path d='M1 1h1L1 2z' overflow='visible'></path>
                </clipPath>
                <clipPath id='aO' clipPath='url(#aM)'>
                  <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                </clipPath>
                <defs>
                  <filter
                    id='aN'
                    width='32.2'
                    height='12.6'
                    x='970.3'
                    y='368.7'
                    filterUnits='userSpaceOnUse'>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'></feColorMatrix>
                  </filter>
                </defs>
                <mask
                  id='aT'
                  width='32.2'
                  height='12.6'
                  x='970.3'
                  y='368.7'
                  maskUnits='userSpaceOnUse'>
                  <g filter='url(#aN)'>
                    <defs>
                      <path d='M1 1h1L1 2z'></path>
                    </defs>
                    <defs>
                      <path d='M-1-1h-1l1-1z'></path>
                    </defs>
                    <clipPath id='aP' clipPath='url(#aO)'>
                      <path d='M1 1h1L1 2z' overflow='visible'></path>
                    </clipPath>
                    <clipPath id='aR' clipPath='url(#aP)'>
                      <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                    </clipPath>
                    <linearGradient
                      id='aQ'
                      x1='986.4'
                      x2='986.4'
                      y1='698.681'
                      y2='710.901'
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'>
                      <stop offset='0' stopColor='#FFF'></stop>
                      <stop offset='1'></stop>
                    </linearGradient>
                    <path
                      fill='url(#aQ)'
                      d='M1002.5 378.4c0 1.2-.7 2.3-1.7 2.9h-1.1v-.3c0-1.3-1.1-2.8-2.4-3.5 0 0-.1 0-.1-.1-.5-.2-1-.4-1.4-.4-.3 0-.6 0-.9.1.1-.2.1-.4.1-.6 0-.9-.7-1.7-1.7-1.7-.7 0-1.3.5-1.6 1.1-.3-.2-.7-.3-1.1-.4-.3-.9-1.2-1.7-2.2-1.7-.5 0-.9.1-1.3.2v4.9h9.7l-.7 2.2H972c-.8-.5-1.4-1.2-1.6-2.2 0-.2-.1-.5-.1-.7 0-1.5 1-2.7 2.3-3.2v-.6c0-2.7 2.2-4.9 4.9-4.9.9 0 1.8.3 2.6.7.7-.9 1.8-1.5 3.1-1.5 1.5 0 2.7.8 3.4 2 .2-.1.4-.1.7-.2h.6c1.4 0 2.6.6 3.4 1.6.7-.6 1.6-.9 2.6-.9 2.2 0 4 1.6 4.3 3.7h.1c.3-.1.7-.2 1-.2 1.7.4 3.2 1.9 3.2 3.7'
                      clipPath='url(#aR)'></path>
                  </g>
                </mask>
                <linearGradient
                  id='aS'
                  x1='986.4'
                  x2='986.4'
                  y1='698.681'
                  y2='710.901'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='1'></stop>
                </linearGradient>
                <path
                  fill='url(#aS)'
                  d='M1002.5 378.4c0 1.2-.7 2.3-1.7 2.9h-1.1v-.3c0-1.3-1.1-2.8-2.4-3.5 0 0-.1 0-.1-.1-.5-.2-1-.4-1.4-.4-.3 0-.6 0-.9.1.1-.2.1-.4.1-.6 0-.9-.7-1.7-1.7-1.7-.7 0-1.3.5-1.6 1.1-.3-.2-.7-.3-1.1-.4-.3-.9-1.2-1.7-2.2-1.7-.5 0-.9.1-1.3.2v4.9h9.7l-.7 2.2H972c-.8-.5-1.4-1.2-1.6-2.2 0-.2-.1-.5-.1-.7 0-1.5 1-2.7 2.3-3.2v-.6c0-2.7 2.2-4.9 4.9-4.9.9 0 1.8.3 2.6.7.7-.9 1.8-1.5 3.1-1.5 1.5 0 2.7.8 3.4 2 .2-.1.4-.1.7-.2h.6c1.4 0 2.6.6 3.4 1.6.7-.6 1.6-.9 2.6-.9 2.2 0 4 1.6 4.3 3.7h.1c.3-.1.7-.2 1-.2 1.7.4 3.2 1.9 3.2 3.7'
                  clipPath='url(#aO)'
                  mask='url(#aT)'></path>
                <linearGradient
                  id='aU'
                  x1='986.4'
                  x2='986.4'
                  y1='698.681'
                  y2='710.901'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='1' stopColor='#9CD0F1'></stop>
                </linearGradient>
                <path
                  fill='url(#aU)'
                  d='M1002.5 378.4c0 1.2-.7 2.3-1.7 2.9h-1.1v-.3c0-1.3-1.1-2.8-2.4-3.5 0 0-.1 0-.1-.1-.5-.2-1-.4-1.4-.4-.3 0-.6 0-.9.1.1-.2.1-.4.1-.6 0-.9-.7-1.7-1.7-1.7-.7 0-1.3.5-1.6 1.1-.3-.2-.7-.3-1.1-.4-.3-.9-1.2-1.7-2.2-1.7-.5 0-.9.1-1.3.2v4.9h9.7l-.7 2.2H972c-.8-.5-1.4-1.2-1.6-2.2 0-.2-.1-.5-.1-.7 0-1.5 1-2.7 2.3-3.2v-.6c0-2.7 2.2-4.9 4.9-4.9.9 0 1.8.3 2.6.7.7-.9 1.8-1.5 3.1-1.5 1.5 0 2.7.8 3.4 2 .2-.1.4-.1.7-.2h.6c1.4 0 2.6.6 3.4 1.6.7-.6 1.6-.9 2.6-.9 2.2 0 4 1.6 4.3 3.7h.1c.3-.1.7-.2 1-.2 1.7.4 3.2 1.9 3.2 3.7'
                  enableBackground='new'
                  opacity='0.5'></path>
                <g fill='#FFF' className='st77' opacity='0.25'>
                  <path
                    d='M976.2 373.9c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c0-.1.2 0 .2.2'
                    className='st30'></path>
                  <circle
                    cx='972.8'
                    cy='379.3'
                    r='0.2'
                    className='st30'></circle>
                  <path
                    d='M982.6 371c0 .1-.1.1-.1.1l-.1-.1.1-.1zM979.1 371.6c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1M989 373.2c-.1.1-.1 0 0 0-.1 0-.1-.1 0 0 0-.1 0 0 0 0M991.6 374.3q0 .15 0 0c-.1.1-.1 0 0 0q-.15 0 0 0M986.8 371.6s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0q0-.15 0 0M980.7 372.9c-.1.1-.1 0 0 0q-.15-.15 0 0 0-.15 0 0M971.1 377.9c-.1.1-.1 0 0 0-.1-.1 0-.1 0 0q0-.15 0 0M975.8 371.9c-.1.1-.1 0 0 0q-.15-.15 0 0 0-.15 0 0M975.2 375.9c0 .1-.1.1 0 0-.1.1-.1 0 0 0-.2 0-.1 0 0 0-.1 0 0 0 0 0'
                    className='st30'></path>
                  <circle
                    cx='992.2'
                    cy='372.6'
                    r='0.1'
                    className='st30'></circle>
                  <circle cx='996' cy='373.2' r='0.1' className='st30'></circle>
                  <path
                    d='M994.6 372.3s-.1 0 0 0q-.15 0 0 0c-.1 0-.1-.1 0 0-.1-.1 0 0 0 0M996.4 375.8s0 .1 0 0c-.1.1-.1 0 0 0q-.15 0 0 0M999 375.7c-.1.1-.1 0 0 0-.1 0-.1-.1 0 0q0-.15 0 0M999.2 378.2c-.1.1-.1 0 0 0q-.15-.15 0 0 0-.15 0 0M1000.9 380q0 .15 0 0c-.1.1-.1 0 0 0q-.15 0 0 0M1000.3 380.8q0 .15 0 0-.15.15 0 0-.15 0 0 0'
                    className='st30'></path>
                </g>
                <linearGradient
                  id='aV'
                  x1='1009.755'
                  x2='1022.805'
                  y1='743.85'
                  y2='743.85'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path fill='url(#aV)' d='M1009.8 331.4h13v9.5h-13z'></path>
                <linearGradient
                  id='aW'
                  x1='1009.45'
                  x2='1009.45'
                  y1='698.7'
                  y2='739.1'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path
                  fill='url(#aW)'
                  d='M1022.8 340.9v40.4h-26.7l.7-2.2.5-1.5.8-2.3 11.7-34.4z'></path>
                <linearGradient
                  id='aX'
                  x1='1022.8'
                  x2='1035.024'
                  y1='718.9'
                  y2='718.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path fill='url(#aX)' d='M1022.8 340.9h12.2v40.4h-12.2z'></path>
                <linearGradient
                  id='aY'
                  x1='1022.8'
                  x2='1035.024'
                  y1='743.85'
                  y2='743.85'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path fill='url(#aY)' d='M1022.8 331.4h12.2v9.5h-12.2z'></path>
                <path
                  fill='#F2F7F7'
                  d='M1021.5 338.3H1011c-.3 0-.5-.2-.5-.5v-3.7c0-.3.2-.5.5-.5h10.5c.3 0 .5.2.5.5v3.7c.1.3-.2.5-.5.5'
                  className='st84'></path>
                <linearGradient
                  id='aZ'
                  x1='1010.714'
                  x2='1021.846'
                  y1='744'
                  y2='744'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#aZ)'
                  d='M1021.8 333.9v4.2s0 .1-.1.1h-11s-.1 0-.1-.1v-4.2s0-.1.1-.1zq0-.15 0 0'></path>
                <g fill='#F2F7F7' className='st77' opacity='0.25'>
                  <path
                    d='m1014.3 333.8-1.4 4.3h-1.2l1.4-4.3zM1021.1 333.8l-1.4 4.3h-3l1.4-4.3z'
                    className='st84'></path>
                </g>
                <path
                  fill='#A7C1D5'
                  d='M1021.8 335.9v2.2s0 .1-.1.1h-11s-.1 0-.1-.1v-1.4h6.8z'
                  className='st113'
                  opacity='0.25'></path>
                <linearGradient
                  id='ba'
                  x1='1010.9'
                  x2='1010.9'
                  y1='741.861'
                  y2='746.209'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#ba)'
                  d='M1011.1 338.1h-.3c-.1 0-.1 0-.1-.1v-4.2c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1z'></path>
                <linearGradient
                  id='bb'
                  x1='1025.55'
                  x2='1025.55'
                  y1='698.7'
                  y2='729.749'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.046' stopColor='#708EB0'></stop>
                  <stop offset='0.129' stopColor='#819EBC'></stop>
                  <stop offset='0.226' stopColor='#8EACC6'></stop>
                  <stop offset='0.347' stopColor='#98B6CE'></stop>
                  <stop offset='0.517' stopColor='#9EBCD2'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path fill='url(#bb)' d='M1020 350.3h11.1v31H1020z'></path>
                <linearGradient
                  id='bc'
                  x1='1035.05'
                  x2='1035.05'
                  y1='698.7'
                  y2='729'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#4C7099'></stop>
                  <stop offset='0.038' stopColor='#57789F'></stop>
                  <stop offset='0.121' stopColor='#6987A8'></stop>
                  <stop offset='0.22' stopColor='#7694B1'></stop>
                  <stop offset='0.342' stopColor='#809EB8'></stop>
                  <stop offset='0.513' stopColor='#86A4BB'></stop>
                  <stop offset='0.989' stopColor='#88A6BD'></stop>
                </linearGradient>
                <path fill='url(#bc)' d='M1031.1 351h7.9v30.3h-7.9z'></path>
                <path
                  fill='#F2F7F7'
                  d='M1029.6 378.3h-8.2c-.5 0-.8-.4-.8-.8v-23c0-.5.4-.8.8-.8h8.2c.5 0 .8.4.8.8v23c.1.4-.3.8-.8.8'
                  className='st84'></path>
                <path
                  fill='#708EB1'
                  d='M1021.4 378.1h-.4c-.1 0-.2-.1-.2-.2v-23.7c0-.1.1-.2.2-.2h.4c-.1 0-.2.1-.2.2v23.7c-.1 0 .1.2.2.2'
                  className='st166'></path>
                <linearGradient
                  id='bd'
                  x1='1017.49'
                  x2='1034.021'
                  y1='705.74'
                  y2='722.271'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.134' stopColor='#7593B4'></stop>
                  <stop offset='0.309' stopColor='#87A5C1'></stop>
                  <stop offset='0.499' stopColor='#95B2CB'></stop>
                  <stop offset='0.711' stopColor='#9DBBD1'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#bd)'
                  d='M1030.3 354.1v23.7c0 .1-.1.2-.2.2h-8.6c-.1 0-.2-.1-.2-.2v-23.7c0-.1.1-.2.2-.2h8.6c0-.1.2 0 .2.2'></path>
                <g fill='#F2F7F7'>
                  <path
                    d='M1020.8 355.4h9.5v.3h-9.5zM1020.8 359.6h9.5v.3h-9.5zM1020.8 363.7h9.5v.3h-9.5zM1020.8 367.9h9.5v.3h-9.5zM1020.8 372h9.5v.3h-9.5zM1020.8 376.2h9.5v.3h-9.5z'
                    className='st84'></path>
                </g>
                <linearGradient
                  id='be'
                  x1='1033.55'
                  x2='1033.55'
                  y1='729.001'
                  y2='729.73'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path
                  fill='url(#be)'
                  d='M1039.2 351h-11.3c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h11.3c.2 0 .4.2.4.4s-.2.4-.4.4'></path>
                <linearGradient
                  id='bf'
                  x1='1025.45'
                  x2='1025.45'
                  y1='729.001'
                  y2='729.73'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path
                  fill='url(#bf)'
                  d='M1031.1 351h-11.3c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h11.3c.2 0 .4.2.4.4s-.2.4-.4.4'></path>
                <g fill='#F2F7F7' className='st77' opacity='0.25'>
                  <path
                    d='m1024.5 353.8-3.4 10.6v-3.1l2.4-7.5zM1030.3 354.1v10.8l-4.1 13.2h-4.2l7.6-24.2h.4c.1-.1.3 0 .3.2'
                    className='st84'></path>
                </g>
                <defs>
                  <path d='M1 1h1L1 2z'></path>
                </defs>
                <defs>
                  <path d='M-1-1h-1l1-1z'></path>
                </defs>
                <clipPath id='bg'>
                  <path d='M1 1h1L1 2z' overflow='visible'></path>
                </clipPath>
                <clipPath id='bi' clipPath='url(#bg)'>
                  <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                </clipPath>
                <defs>
                  <filter
                    id='bh'
                    width='11.1'
                    height='0.7'
                    x='1020'
                    y='351'
                    filterUnits='userSpaceOnUse'>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'></feColorMatrix>
                  </filter>
                </defs>
                <mask
                  id='bn'
                  width='11.1'
                  height='0.7'
                  x='1020'
                  y='351'
                  maskUnits='userSpaceOnUse'>
                  <g filter='url(#bh)'>
                    <defs>
                      <path d='M1 1h1L1 2z'></path>
                    </defs>
                    <defs>
                      <path d='M-1-1h-1l1-1z'></path>
                    </defs>
                    <clipPath id='bj' clipPath='url(#bi)'>
                      <path d='M1 1h1L1 2z' overflow='visible'></path>
                    </clipPath>
                    <clipPath id='bl' clipPath='url(#bj)'>
                      <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                    </clipPath>
                    <linearGradient
                      id='bk'
                      x1='1025.55'
                      x2='1025.55'
                      y1='729.001'
                      y2='728.336'
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'>
                      <stop offset='0' stopColor='#FFF'></stop>
                      <stop offset='0.118' stopColor='#C6C6C6'></stop>
                      <stop offset='0.242' stopColor='#929292'></stop>
                      <stop offset='0.367' stopColor='#656565'></stop>
                      <stop offset='0.492' stopColor='#414141'></stop>
                      <stop offset='0.617' stopColor='#242424'></stop>
                      <stop offset='0.742' stopColor='#101010'></stop>
                      <stop offset='0.866' stopColor='#040404'></stop>
                      <stop offset='0.989'></stop>
                    </linearGradient>
                    <path
                      fill='url(#bk)'
                      d='M1020 351h11.1v.7H1020z'
                      clipPath='url(#bl)'></path>
                  </g>
                </mask>
                <linearGradient
                  id='bm'
                  x1='1025.55'
                  x2='1025.55'
                  y1='729.001'
                  y2='728.336'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='0.118' stopColor='#C6C6C6'></stop>
                  <stop offset='0.242' stopColor='#929292'></stop>
                  <stop offset='0.367' stopColor='#656565'></stop>
                  <stop offset='0.492' stopColor='#414141'></stop>
                  <stop offset='0.617' stopColor='#242424'></stop>
                  <stop offset='0.742' stopColor='#101010'></stop>
                  <stop offset='0.866' stopColor='#040404'></stop>
                  <stop offset='0.989'></stop>
                </linearGradient>
                <path
                  fill='url(#bm)'
                  d='M1020 351h11.1v.7H1020z'
                  clipPath='url(#bi)'
                  mask='url(#bn)'></path>
                <linearGradient
                  id='bo'
                  x1='1025.55'
                  x2='1025.55'
                  y1='729.001'
                  y2='728.336'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#4C7099'></stop>
                  <stop offset='0.053' stopColor='#53749C'></stop>
                  <stop offset='0.287' stopColor='#6A88A9'></stop>
                  <stop offset='0.522' stopColor='#7A98B3'></stop>
                  <stop offset='0.756' stopColor='#84A2BA'></stop>
                  <stop offset='0.989' stopColor='#88A6BD'></stop>
                </linearGradient>
                <path fill='url(#bo)' d='M1020 351h11.1v.7H1020z'></path>
                <defs>
                  <path d='M1 1h1L1 2z'></path>
                </defs>
                <defs>
                  <path d='M-1-1h-1l1-1z'></path>
                </defs>
                <clipPath id='bp'>
                  <path d='M1 1h1L1 2z' overflow='visible'></path>
                </clipPath>
                <clipPath id='br' clipPath='url(#bp)'>
                  <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                </clipPath>
                <defs>
                  <filter
                    id='bq'
                    width='7.9'
                    height='0.7'
                    x='1031.1'
                    y='351'
                    filterUnits='userSpaceOnUse'>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'></feColorMatrix>
                  </filter>
                </defs>
                <mask
                  id='bw'
                  width='7.9'
                  height='0.7'
                  x='1031.1'
                  y='351'
                  maskUnits='userSpaceOnUse'>
                  <g filter='url(#bq)'>
                    <defs>
                      <path d='M1 1h1L1 2z'></path>
                    </defs>
                    <defs>
                      <path d='M-1-1h-1l1-1z'></path>
                    </defs>
                    <clipPath id='bs' clipPath='url(#br)'>
                      <path d='M1 1h1L1 2z' overflow='visible'></path>
                    </clipPath>
                    <clipPath id='bu' clipPath='url(#bs)'>
                      <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                    </clipPath>
                    <linearGradient
                      id='bt'
                      x1='1035.05'
                      x2='1035.05'
                      y1='729.001'
                      y2='728.336'
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'>
                      <stop offset='0' stopColor='#FFF'></stop>
                      <stop offset='0.118' stopColor='#C6C6C6'></stop>
                      <stop offset='0.242' stopColor='#929292'></stop>
                      <stop offset='0.367' stopColor='#656565'></stop>
                      <stop offset='0.492' stopColor='#414141'></stop>
                      <stop offset='0.617' stopColor='#242424'></stop>
                      <stop offset='0.742' stopColor='#101010'></stop>
                      <stop offset='0.866' stopColor='#040404'></stop>
                      <stop offset='0.989'></stop>
                    </linearGradient>
                    <path
                      fill='url(#bt)'
                      d='M1031.1 351h7.9v.7h-7.9z'
                      clipPath='url(#bu)'></path>
                  </g>
                </mask>
                <linearGradient
                  id='bv'
                  x1='1035.05'
                  x2='1035.05'
                  y1='729.001'
                  y2='728.336'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='0.118' stopColor='#C6C6C6'></stop>
                  <stop offset='0.242' stopColor='#929292'></stop>
                  <stop offset='0.367' stopColor='#656565'></stop>
                  <stop offset='0.492' stopColor='#414141'></stop>
                  <stop offset='0.617' stopColor='#242424'></stop>
                  <stop offset='0.742' stopColor='#101010'></stop>
                  <stop offset='0.866' stopColor='#040404'></stop>
                  <stop offset='0.989'></stop>
                </linearGradient>
                <path
                  fill='url(#bv)'
                  d='M1031.1 351h7.9v.7h-7.9z'
                  clipPath='url(#br)'
                  mask='url(#bw)'></path>
                <linearGradient
                  id='bx'
                  x1='1035.05'
                  x2='1035.05'
                  y1='729.001'
                  y2='728.336'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#4C7099'></stop>
                  <stop offset='0.053' stopColor='#53749C'></stop>
                  <stop offset='0.287' stopColor='#6A88A9'></stop>
                  <stop offset='0.522' stopColor='#7A98B3'></stop>
                  <stop offset='0.756' stopColor='#84A2BA'></stop>
                  <stop offset='0.989' stopColor='#88A6BD'></stop>
                </linearGradient>
                <path fill='url(#bx)' d='M1031.1 351h7.9v.7h-7.9z'></path>
                <path
                  fill='#C1DADD'
                  d='M1021.5 347.9v.3c0 .4-.3.7-.7.7h-1.8c-1.1 0-1.9.9-1.9 1.9v30.6h-1.4v-30.8c0-1.4 1.1-2.5 2.5-2.5h3c.1-.1.2-.1.3-.2M1014.9 348c0 .1-.1.1-.1.1-.5.7-.8 1.5-.8 2.4v30.900000000000002h-1.4v-30.8c.1-1.4 1-2.4 2.3-2.6M1011.9 348c0 .1-.1.1-.1.1-.5.7-.8 1.5-.8 2.4v30.900000000000002h-1.4v-30.8c.1-1.4 1-2.4 2.3-2.6'
                  className='st184'
                  opacity='0.4'></path>
                <path
                  fill='#E4EAEA'
                  d='M1015.6 347.2c0 .5-.3.8-.6.8h-2.7c-1.4 0-2.5 1.1-2.5 2.5v30.8h-1.7v-30.8c0-2.3 1.9-4.2 4.2-4.2h2.7c.3 0 .6.4.6.9'
                  className='st185'></path>
                <path
                  fill='#E4EAEA'
                  d='M1018.6 347.2c0 .5-.3.8-.6.8h-2.7c-1.4 0-2.5 1.1-2.5 2.5v30.8h-1.7v-30.8c0-2.3 1.9-4.2 4.2-4.2h2.7c.3 0 .6.4.6.9'
                  className='st185'></path>
                <path
                  fill='#C1DADD'
                  d='M1015.2 347.6c-.1.1-.2.3-.3.4-1.2.2-2.2 1.2-2.2 2.5v30.8h-.5v-30.9c0-1.6 1.3-2.8 2.8-2.8zM1012.2 347.6c-.1.1-.2.3-.3.4-1.2.2-2.2 1.2-2.2 2.5v30.8h-.5v-30.9c0-1.6 1.3-2.8 2.8-2.8z'
                  className='st186'></path>
                <path
                  fill='#E4EAEA'
                  d='M1015.4 347.2c0 .2 0 .3-.1.5s-.3.4-.5.4h-2.7c-.2 0-.4 0-.6.1-.1 0-.1 0-.2.1-.4.1-.8.4-1.1.7s-.5.8-.6 1.2v31.3h-1.7v-31.6c.1-.6.4-1.1.7-1.6 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.4-.4.9-.8 1.5-1 .1 0 .1-.1.2-.1h.3c.3-.1.6-.1 1-.1h2.7c.2 0 .3.1.5.3v.1c.2-.2.2-.1.2.2q0-.15 0 0'
                  className='st185'></path>
                <linearGradient
                  id='by'
                  x1='1014.808'
                  x2='1015.707'
                  y1='732.682'
                  y2='732.682'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#by)'
                  d='M1015.7 347.2c0 .3-.2.6-.4.8-.1 0-.2.1-.2.1h-.3.1l.1-.1c.1-.1.1-.3.1-.5 0-.5-.3-.8-.6-.8h.3c.6-.4.9 0 .9.5'></path>
                <path
                  fill='#C1DADD'
                  d='M1015.3 347.6c-.1.2-.3.4-.5.4h-2.7c-1.3 0-2.3.9-2.5 2.1v31.2h-.5v-31.4c.2-1.3 1.4-2.4 2.8-2.4z'
                  className='st186'></path>
                <linearGradient
                  id='bz'
                  x1='1008.75'
                  x2='1008.75'
                  y1='726.179'
                  y2='726.454'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bz)'
                  d='M1009.6 353.8h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1 0 .1-.1.1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1007.9 353.8h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bA'
                  x1='1008.75'
                  x2='1008.75'
                  y1='721.088'
                  y2='721.363'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bA)'
                  d='M1009.6 358.9h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1 0 .1-.1.1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1007.9 358.9h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bB'
                  x1='1008.75'
                  x2='1008.75'
                  y1='715.996'
                  y2='716.272'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bB)'
                  d='M1009.6 364h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1z'></path>
                <path
                  fill='#C1DADD'
                  d='M1007.9 364h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bC'
                  x1='1008.75'
                  x2='1008.75'
                  y1='710.905'
                  y2='711.18'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bC)'
                  d='M1009.6 369.1h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1z'></path>
                <path
                  fill='#C1DADD'
                  d='M1007.9 369.1h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bD'
                  x1='1008.75'
                  x2='1008.75'
                  y1='705.813'
                  y2='706.089'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bD)'
                  d='M1009.6 374.2h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1z'></path>
                <path
                  fill='#C1DADD'
                  d='M1007.9 374.2h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bE'
                  x1='1008.75'
                  x2='1008.75'
                  y1='700.722'
                  y2='700.997'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bE)'
                  d='M1009.6 379.3h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1z'></path>
                <path
                  fill='#C1DADD'
                  d='M1007.9 379.3h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bF'
                  x1='2458.763'
                  x2='2458.763'
                  y1='197.763'
                  y2='198.038'
                  gradientTransform='scale(1 -1)rotate(-13.644 -555.094 5983.89)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bF)'
                  d='m1009.6 350.1-1.6-.4c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.6.4c.1 0 .1.1.1.2s-.1.1-.2.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1009.6 350.1v.2l-.5-.1-1.2-.3v-.2l1.2.3zM1011.4 348.1c-.1 0-.1 0-.2.1v-.1c.3-1-.4-1.5-.4-1.5h.2l.3.3c.2.1.3.6.1 1.2'
                  className='st186'></path>
                <linearGradient
                  id='bG'
                  x1='1010.914'
                  x2='1011.683'
                  y1='732.737'
                  y2='732.737'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bG)'
                  d='M1011.5 348.2c-.1 0-.1-.1-.1-.1.3-1-.4-1.5-.4-1.5-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.4.4s.3.7.1 1.3c-.1 0-.2.1-.2.1'></path>
                <path
                  fill='#E4EAEA'
                  d='M1018.5 347.2c0 .2 0 .3-.1.5s-.3.4-.5.4h-2.7c-.2 0-.4 0-.6.1-.1 0-.1 0-.2.1-.4.1-.8.4-1.1.7s-.5.8-.6 1.2v31.3h-1.7v-31.6c.1-.6.4-1.1.7-1.6 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.4-.4.9-.8 1.5-1 .1 0 .1-.1.2-.1h.3c.3-.1.6-.1 1-.1h2.7c.2 0 .3.1.5.3v.1c.1-.2.2-.1.2.2q0-.15 0 0'
                  className='st185'></path>
                <linearGradient
                  id='bH'
                  x1='1017.873'
                  x2='1018.772'
                  y1='732.682'
                  y2='732.682'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bH)'
                  d='M1018.8 347.2c0 .3-.2.6-.4.8-.1 0-.2.1-.2.1h-.3.1l.1-.1c.1-.1.1-.3.1-.5 0-.5-.3-.8-.6-.8h.3c.6-.4.9 0 .9.5'></path>
                <path
                  fill='#C1DADD'
                  d='M1018.4 347.6c-.1.2-.3.4-.5.4h-2.7c-1.3 0-2.3.9-2.5 2.1v31.2h-.5v-31.4c.2-1.3 1.4-2.4 2.8-2.4z'
                  className='st186'></path>
                <linearGradient
                  id='bI'
                  x1='1011.771'
                  x2='1011.771'
                  y1='726.179'
                  y2='726.454'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bI)'
                  d='M1012.6 353.8h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1.1.1 0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1011 353.8h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bJ'
                  x1='1011.771'
                  x2='1011.771'
                  y1='721.088'
                  y2='721.363'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bJ)'
                  d='M1012.6 358.9h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1.1.1 0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1011 358.9h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bK'
                  x1='1011.771'
                  x2='1011.771'
                  y1='715.996'
                  y2='716.272'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bK)'
                  d='M1012.6 364h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1.1 0 0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1011 364h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bL'
                  x1='1011.771'
                  x2='1011.771'
                  y1='710.905'
                  y2='711.18'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bL)'
                  d='M1012.6 369.1h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1.1 0 0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1011 369.1h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bM'
                  x1='1011.771'
                  x2='1011.771'
                  y1='705.813'
                  y2='706.089'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bM)'
                  d='M1012.6 374.2h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1.1 0 0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1011 374.2h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bN'
                  x1='1011.771'
                  x2='1011.771'
                  y1='700.722'
                  y2='700.997'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bN)'
                  d='M1012.6 379.3h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1.1 0 0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1011 379.3h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bO'
                  x1='2461.774'
                  x2='2461.774'
                  y1='198.486'
                  y2='198.761'
                  gradientTransform='scale(1 -1)rotate(-13.644 -555.094 5983.89)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bO)'
                  d='m1012.7 350.1-1.6-.4c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.6.4c.1 0 .1.1.1.2-.1.1-.1.1-.2.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1012.7 350.1v.2l-.5-.1-1.2-.3v-.2l1.2.3zM1014.5 348.1c-.1 0-.1 0-.2.1v-.1c.3-1-.4-1.5-.4-1.5h.2l.3.3c.2.1.3.6.1 1.2'
                  className='st186'></path>
                <linearGradient
                  id='bP'
                  x1='1013.979'
                  x2='1014.748'
                  y1='732.737'
                  y2='732.737'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bP)'
                  d='M1014.5 348.2c-.1 0-.1-.1-.1-.1.3-1-.4-1.5-.4-1.5-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.4.4s.3.7.1 1.3c-.1 0-.1.1-.2.1'></path>
                <path
                  fill='#E4EAEA'
                  d='M1021.6 347.2c0 .2 0 .3-.1.5s-.3.4-.5.4h-2.7c-.2 0-.4 0-.6.1-.1 0-.1 0-.2.1-.4.1-.8.4-1.1.7s-.5.8-.6 1.2v31.3h-1.7v-31.6c.1-.6.4-1.1.7-1.6 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.4-.4.9-.8 1.5-1 .1 0 .1-.1.2-.1h.3c.3-.1.6-.1 1-.1h2.7c.2 0 .3.1.5.3v.1c.1-.2.1-.1.2.2q0-.15 0 0'
                  className='st185'></path>
                <linearGradient
                  id='bQ'
                  x1='1020.938'
                  x2='1021.837'
                  y1='732.682'
                  y2='732.682'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bQ)'
                  d='M1021.8 347.2c0 .3-.2.6-.4.8-.1 0-.2.1-.2.1h-.3.1l.1-.1c.1-.1.1-.3.1-.5 0-.5-.3-.8-.6-.8h.3c.7-.4.9 0 .9.5'></path>
                <path
                  fill='#C1DADD'
                  d='M1021.5 347.6c-.1.2-.3.4-.5.4h-2.7c-1.3 0-2.3.9-2.5 2.1v31.2h-.5v-31.4c.2-1.3 1.4-2.4 2.8-2.4z'
                  className='st186'></path>
                <linearGradient
                  id='bR'
                  x1='1014.85'
                  x2='1014.85'
                  y1='726.179'
                  y2='726.454'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bR)'
                  d='M1015.7 353.8h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1 0 .1 0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1014 353.8h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bS'
                  x1='1014.85'
                  x2='1014.85'
                  y1='721.088'
                  y2='721.363'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bS)'
                  d='M1015.7 358.9h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1 0 .1 0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1014 358.9h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bT'
                  x1='1014.85'
                  x2='1014.85'
                  y1='715.996'
                  y2='716.272'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bT)'
                  d='M1015.7 364h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1s0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1014 364h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bU'
                  x1='1014.85'
                  x2='1014.85'
                  y1='710.905'
                  y2='711.18'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bU)'
                  d='M1015.7 369.1h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1s0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1014 369.1h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bV'
                  x1='1014.85'
                  x2='1014.85'
                  y1='705.813'
                  y2='706.089'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bV)'
                  d='M1015.7 374.2h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1s0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1014 374.2h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bW'
                  x1='1014.85'
                  x2='1014.85'
                  y1='700.722'
                  y2='700.997'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bW)'
                  d='M1015.7 379.3h-1.7c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.7c.1 0 .1.1.1.1s0 .1-.1.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1014 379.3h1.7v.2h-1.7z'
                  className='st186'></path>
                <linearGradient
                  id='bX'
                  x1='2464.786'
                  x2='2464.786'
                  y1='199.209'
                  y2='199.484'
                  gradientTransform='scale(1 -1)rotate(-13.644 -555.094 5983.89)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bX)'
                  d='m1015.8 350.1-1.6-.4c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.6.4c.1 0 .1.1.1.2-.1.1-.2.1-.2.1'></path>
                <path
                  fill='#C1DADD'
                  d='M1015.7 350.1v.2l-.5-.1-1.2-.3v-.2l1.2.3zM1017.6 348.1c-.1 0-.1 0-.2.1v-.1c.3-1-.4-1.5-.4-1.5h.2l.3.3c.1.1.3.6.1 1.2'
                  className='st186'></path>
                <linearGradient
                  id='bY'
                  x1='1017.044'
                  x2='1017.813'
                  y1='732.737'
                  y2='732.737'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#bY)'
                  d='M1017.6 348.2c-.1 0-.1-.1-.1-.1.3-1-.4-1.5-.4-1.5-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.4.4s.3.7.1 1.3c-.1 0-.1.1-.2.1'></path>
                <linearGradient
                  id='bZ'
                  x1='930.7'
                  x2='930.7'
                  y1='698.681'
                  y2='700.86'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#79AACE'></stop>
                  <stop offset='0.612' stopColor='#6BA4CE'></stop>
                  <stop offset='1' stopColor='#DCEFFB'></stop>
                </linearGradient>
                <path
                  fill='url(#bZ)'
                  d='m996.8 379.1-.7 2.2H865.5c-.5 0-.9-.4-.9-.9 0-.7.6-1.2 1.2-1.2h131z'></path>
              </g>
              <g transform='matrix(1.12946 0 0 1.21855 -677.162 -413.619)'>
                <linearGradient
                  id='ca'
                  x1='211.023'
                  x2='227.023'
                  y1='695.25'
                  y2='695.25'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path
                  fill='url(#ca)'
                  d='m227 372.5-6.3 24.5H211v-8.4l6.2-1.8 3.7-14.3z'></path>
                <linearGradient
                  id='cb'
                  x1='214.767'
                  x2='217.918'
                  y1='694.047'
                  y2='706.791'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path
                  fill='url(#cb)'
                  d='m220.9 372.5-.1.6v.1l-.7 2.4v.1l-.6 2.5-.1.1-.6 2.4v.1l-.7 2.5v.1l-.6 2.4v.1l-.3.9h-5.5l.2-.9.1-.1.6-2.4v-.1l.6-2.5.1-.1.6-2.4v-.1l.7-2.5v-.1l.6-2.4.1-.1.1-.6z'></path>
                <path
                  fill='#EFF4F4'
                  d='m211 388.6 6.2-1.8h-5.5l-6.2 1.8z'
                  className='st217'></path>
                <linearGradient
                  id='cc'
                  x1='208.25'
                  x2='208.25'
                  y1='683.037'
                  y2='691.416'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path fill='url(#cc)' d='M205.5 388.6h5.5v8.4h-5.5z'></path>
                <linearGradient
                  id='cd'
                  x1='238.487'
                  x2='238.538'
                  y1='701.969'
                  y2='707.182'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.053' stopColor='#6B8AAD'></stop>
                  <stop offset='0.24' stopColor='#809EBC'></stop>
                  <stop offset='0.429' stopColor='#90AFC8'></stop>
                  <stop offset='0.618' stopColor='#9BB9D0'></stop>
                  <stop offset='0.809' stopColor='#9EBDD3'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#cd)'
                  d='m224.3 372.5.2 5.6-.7 2.8H251l2.2-8.4z'></path>
                <linearGradient
                  id='ce'
                  x1='237.75'
                  x2='237.75'
                  y1='699.344'
                  y2='701.644'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#6383A8'></stop>
                  <stop offset='0.053' stopColor='#6B8AAD'></stop>
                  <stop offset='0.24' stopColor='#809EBC'></stop>
                  <stop offset='0.429' stopColor='#90AFC8'></stop>
                  <stop offset='0.618' stopColor='#9BB9D0'></stop>
                  <stop offset='0.809' stopColor='#9EBDD3'></stop>
                  <stop offset='0.989' stopColor='#A0BED4'></stop>
                </linearGradient>
                <path
                  fill='url(#ce)'
                  d='m251.7 378.1-.7 2.8h-27.2v-.2l.7-2.6z'></path>
                <path
                  fill='#9FB7CE'
                  d='m251 380.9-.2.6-.2.7h-22.5c-.7 0-2.9-.1-4.1.6-.1.1-.2.1-.3.2v-2.2z'
                  className='st222'></path>
                <path
                  fill='#576E82'
                  d='m250.8 381.5-.2.7h-22.5c-.7 0-2.9-.1-4.1.6v-.1c0-.7.6-1.2 1.2-1.2z'
                  className='st223'></path>
                <linearGradient
                  id='cf'
                  x1='235'
                  x2='235'
                  y1='683.037'
                  y2='697.755'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#79AACE'></stop>
                  <stop offset='0.584' stopColor='#95C9ED'></stop>
                  <stop offset='0.763' stopColor='#B8DDF5'></stop>
                  <stop offset='0.897' stopColor='#6BA4CE'></stop>
                  <stop offset='1' stopColor='#9CD0F1'></stop>
                </linearGradient>
                <path
                  fill='url(#cf)'
                  d='m250.6 382.2-.8 14.7h-30.4c0-1.7.1-3.3.4-4.8v-.1q.3-1.5.6-2.7v-.1c.4-1.3.8-2.4 1.3-3.3 0 0 0-.1.1-.1.5-1.1 1.1-1.9 1.6-2.4l.1-.1.2-.2c1-.9 3.6-.8 4.3-.8h22.6z'></path>
                <path
                  fill='#576E82'
                  d='M215.4 371.6h43.3v.9h-43.3z'
                  className='st223'></path>
                <path
                  fill='#DEE8F0'
                  d='M226 377.8c-.1 0-.3-.1-.3-.3l-.1-2.2c0-.1 0-.1.1-.2s.1-.1.2-.1h1.3c.1 0 .3.1.3.3l.1 2.2c0 .1 0 .1-.1.2s-.1.1-.2.1z'
                  className='st225'></path>
                <path
                  fill='#A7C1D5'
                  d='M227.4 377.5c0 .1-.1.2-.2.2H226c-.1 0-.2-.1-.2-.2l-.1-2.2c0-.1.1-.2.2-.2h1.3c.1 0 .2.1.2.2v2.2'
                  className='st226'></path>
                <path
                  fill='#576E82'
                  d='M227.4 377.5c0 .1-.1.2-.2.2h-.8c-.1 0-.2-.1-.2-.2l-.1-2.2c0-.1.1-.2.2-.2h.8c.1 0 .2.1.2.2v.1z'
                  className='st223'></path>
                <path
                  fill='#DEE8F0'
                  d='M238.6 377.8c-.1 0-.3-.1-.3-.3l-.1-2.2c0-.1 0-.1.1-.2s.1-.1.2-.1h1.3c.1 0 .3.1.3.3l.1 2.2c0 .1 0 .1-.1.2s-.1.1-.2.1z'
                  className='st225'></path>
                <path
                  fill='#A7C1D5'
                  d='M240 377.5c0 .1-.1.2-.2.2h-1.3c-.1 0-.2-.1-.2-.2l-.1-2.2c0-.1.1-.2.2-.2h1.3c.1 0 .2.1.2.2v.1z'
                  className='st226'></path>
                <path
                  fill='#576E82'
                  d='M240 377.5c0 .1-.1.2-.2.2h-.8c-.1 0-.2-.1-.2-.2l-.1-2.2c0-.1.1-.2.2-.2h.8c.1 0 .2.1.2.2v.1z'
                  className='st223'></path>
                <path
                  fill='#DEE8F0'
                  d='M251.2 377.8c-.1 0-.3-.1-.3-.3l-.1-2.2c0-.1 0-.1.1-.2s.1-.1.2-.1h1.3c.1 0 .3.1.3.3l.1 2.2c0 .1 0 .1-.1.2s-.1.1-.2.1z'
                  className='st225'></path>
                <path
                  fill='#A7C1D5'
                  d='M252.6 377.5c0 .1-.1.2-.2.2h-1.3c-.1 0-.2-.1-.2-.2l-.1-2.2c0-.1.1-.2.2-.2h1.3c.1 0 .2.1.2.2v.1z'
                  className='st226'></path>
                <path
                  fill='#576E82'
                  d='M252.6 377.5c0 .1-.1.2-.2.2h-.8c-.1 0-.2-.1-.2-.2l-.1-2.2c0-.1.1-.2.2-.2h.8c.1 0 .2.1.2.2v.1z'
                  className='st223'></path>
                <linearGradient
                  id='cg'
                  x1='256.8'
                  x2='256.8'
                  y1='683.037'
                  y2='707.487'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path
                  fill='url(#cg)'
                  d='M264.8 372.5V397h-16v-8.4l6.2-1.8.2-.9.1-.1.6-2.4v-.1l.7-2.5v-.1l.6-2.4.1-.1.6-2.5.6-2.5.1-.1.1-.6z'></path>
                <linearGradient
                  id='ch'
                  x1='252.537'
                  x2='255.487'
                  y1='693.337'
                  y2='706.528'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path
                  fill='url(#ch)'
                  d='m258.7 372.5-.1.6-.1.1-.6 2.4v.1l-.6 2.5-.1.1-.6 2.4v.1l-.7 2.5v.1l-.6 2.4-.1.1-.2.9h-5.5l.2-.9v-.1l.7-2.4v-.1l.6-2.5.1-.1.6-2.4v-.1l.7-2.5v-.1l.6-2.4v-.1l.2-.6z'></path>
                <path
                  fill='#EFF4F4'
                  d='m248.8 388.6 6.2-1.8h-5.5l-6.2 1.8z'
                  className='st217'></path>
                <linearGradient
                  id='ci'
                  x1='246.05'
                  x2='246.05'
                  y1='683.037'
                  y2='691.416'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#D7E7E6'></stop>
                </linearGradient>
                <path fill='url(#ci)' d='M243.3 388.6h5.5v8.4h-5.5z'></path>
                <path
                  fill='#425362'
                  d='M258.7 371.6h6.1v.9h-6.1z'
                  className='st230'></path>
                <g fill='#A5B8BF' className='st77' opacity='0.25'>
                  <path
                    d='M215.3 373.1h5.5v.1h-5.6z'
                    className='st231'
                    opacity='0.5'></path>
                  <path d='m258.6 373.1-.1.1H253v-.1z' className='st232'></path>
                  <path
                    d='M214.6 375.6h5.5v.1h-5.5z'
                    className='st231'
                    opacity='0.5'></path>
                  <path d='M257.9 375.6v.1h-5.5v-.1z' className='st232'></path>
                  <path
                    d='M213.9 378.2h5.6l-.1.1h-5.5z'
                    className='st231'
                    opacity='0.5'></path>
                  <path
                    d='m257.3 378.2-.1.1h-5.5v-.1z'
                    className='st232'></path>
                  <path
                    d='M213.3 380.7h5.5v.1h-5.6z'
                    className='st231'
                    opacity='0.5'></path>
                  <path d='M256.6 380.7v.1H251l.1-.1z' className='st232'></path>
                  <path
                    d='M212.6 383.3h5.5v.1h-5.5z'
                    className='st231'
                    opacity='0.5'></path>
                  <path d='M255.9 383.3v.1h-5.5v-.1z' className='st232'></path>
                  <path
                    d='M217.5 385.8v.1h-5.6v-.1z'
                    className='st231'
                    opacity='0.5'></path>
                  <path
                    d='m255.3 385.8-.1.1h-5.5v-.1z'
                    className='st232'></path>
                </g>
                <path
                  fill='#A5B8BF'
                  d='M243.3 389.2h5.5v.1h-5.5z'
                  className='st232'></path>
                <g fill='#A5B8BF' className='st77' opacity='0.25'>
                  <path
                    d='M264.8 373.1v.1h-6.3l.1-.1zM264.8 375.6v.1h-6.9v-.1zM264.8 378.2v.1h-7.6l.1-.1zM264.8 380.7v.1h-8.2v-.1zM264.8 383.3v.1h-8.9v-.1zM264.8 385.8v.1h-9.6l.1-.1zM248.8 389.2h16v.1h-16zM248.8 392.1h16v.1h-16z'
                    className='st232'></path>
                </g>
                <path
                  fill='#A5B8BF'
                  d='M243.3 392.1h5.5v.1h-5.5z'
                  className='st232'></path>
                <path
                  fill='#A5B8BF'
                  d='M205.5 389.2h5.5v.1h-5.5zM205.5 392.1h5.5v.1h-5.5z'
                  className='st231'
                  opacity='0.5'></path>
                <g fill='#A5B8BF'>
                  <path
                    d='M220.5 389.2v.1H211v-.1zM219.8 392.1v.1H211v-.1zM221.8 385.8s0 .1-.1.1h-4.3v-.1zM223.6 383.3l-.1.1h-5.3v-.1zM223.8 380.7v.1h-5v-.1zM224.5 378.2v.1h-5.1l.1-.1zM220.1 375.7h4.3v-.1h-4.3zM220.8 373.2h3.5v-.1h-3.5z'
                    className='st233'
                    opacity='0.25'></path>
                </g>
                <path
                  fill='#F47A26'
                  d='M258.7 370.6h-.2V369h.2c.1 0 .3.1.3.3v1q-.15.3-.3.3'
                  className='st234'></path>
                <linearGradient
                  id='cj'
                  x1='237.05'
                  x2='237.05'
                  y1='709.417'
                  y2='710.951'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#F57E20'></stop>
                  <stop offset='0.287' stopColor='#F8993C'></stop>
                  <stop offset='0.583' stopColor='#FBB259'></stop>
                  <stop offset='0.832' stopColor='#FDC16B'></stop>
                  <stop offset='1' stopColor='#FEC771'></stop>
                </linearGradient>
                <path
                  fill='url(#cj)'
                  d='M258.7 369.2v1.3c0 .1-.1.1-.1.1h-43.1c-.1 0-.1-.1-.1-.1v-1.3c0-.1.1-.1.1-.1h43.1c.1-.1.1 0 .1.1'></path>
                <g fill='#4D6380'>
                  <path
                    d='M216.9 370.6h-1.3l.8-1.6h1.3zM220.8 370.6h-1.3l.8-1.6h1.3zM224.7 370.6h-1.3l.8-1.6h1.3zM228.6 370.6h-1.3l.8-1.6h1.3zM232.6 370.6h-1.4l.8-1.6h1.4zM236.5 370.6h-1.3l.7-1.6h1.4zM240.4 370.6h-1.3l.8-1.6h1.3zM244.3 370.6H243l.8-1.6h1.3zM248.2 370.6h-1.3l.8-1.6h1.3zM252.1 370.6h-1.3l.8-1.6h1.3zM256 370.6h-1.3l.8-1.6h1.3z'
                    className='st236'></path>
                </g>
                <linearGradient
                  id='ck'
                  x1='219.382'
                  x2='219.894'
                  y1='708.9'
                  y2='708.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path fill='url(#ck)' d='M219.4 370.6h.5v1h-.5z'></path>
                <linearGradient
                  id='cl'
                  x1='227.576'
                  x2='228.088'
                  y1='708.9'
                  y2='708.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path fill='url(#cl)' d='M227.6 370.6h.5v1h-.5z'></path>
                <linearGradient
                  id='cm'
                  x1='235.77'
                  x2='236.282'
                  y1='708.9'
                  y2='708.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path fill='url(#cm)' d='M235.8 370.6h.5v1h-.5z'></path>
                <linearGradient
                  id='cn'
                  x1='243.964'
                  x2='244.476'
                  y1='708.9'
                  y2='708.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path fill='url(#cn)' d='M244 370.6h.5v1h-.5z'></path>
                <linearGradient
                  id='co'
                  x1='252.158'
                  x2='252.67'
                  y1='708.9'
                  y2='708.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path fill='url(#co)' d='M252.2 370.6h.5v1h-.5z'></path>
                <linearGradient
                  id='cp'
                  x1='219.382'
                  x2='219.894'
                  y1='708.9'
                  y2='708.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path
                  fill='url(#cp)'
                  d='M219.4 370.8h.3v.8h.2v-1h-.5z'
                  enableBackground='new'
                  opacity='0.5'></path>
                <linearGradient
                  id='cq'
                  x1='227.576'
                  x2='228.088'
                  y1='708.9'
                  y2='708.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path
                  fill='url(#cq)'
                  d='M227.6 370.8h.3v.8h.2v-1h-.5z'
                  enableBackground='new'
                  opacity='0.5'></path>
                <linearGradient
                  id='cr'
                  x1='235.77'
                  x2='236.282'
                  y1='708.9'
                  y2='708.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path
                  fill='url(#cr)'
                  d='M235.8 370.8h.3v.8h.2v-1h-.5z'
                  enableBackground='new'
                  opacity='0.5'></path>
                <linearGradient
                  id='cs'
                  x1='243.964'
                  x2='244.476'
                  y1='708.9'
                  y2='708.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path
                  fill='url(#cs)'
                  d='M244 370.8h.3v.8h.2v-1h-.5z'
                  enableBackground='new'
                  opacity='0.5'></path>
                <linearGradient
                  id='ct'
                  x1='252.158'
                  x2='252.67'
                  y1='708.9'
                  y2='708.9'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9BB0B5'></stop>
                  <stop offset='1' stopColor='#B6C5C7'></stop>
                </linearGradient>
                <path
                  fill='url(#ct)'
                  d='M252.2 370.8h.3v.8h.2v-1h-.5z'
                  enableBackground='new'
                  opacity='0.5'></path>
                <linearGradient
                  id='cu'
                  x1='238.75'
                  x2='238.75'
                  y1='706.814'
                  y2='707.433'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0.011' stopColor='#FFF'></stop>
                  <stop offset='0.266' stopColor='#FAFBFC'></stop>
                  <stop offset='0.42' stopColor='#F0F1F5'></stop>
                  <stop offset='0.547' stopColor='#E1E4EC'></stop>
                  <stop offset='0.66' stopColor='#CDD3E0'></stop>
                  <stop offset='0.763' stopColor='#B5BFD3'></stop>
                  <stop offset='0.858' stopColor='#98A9C3'></stop>
                  <stop offset='0.947' stopColor='#7991B2'></stop>
                  <stop offset='1' stopColor='#6383A8'></stop>
                </linearGradient>
                <path fill='url(#cu)' d='M252.9 373.5h-28.5l-.1-1h28.9z'></path>
                <g className='st77' opacity='0.25'>
                  <linearGradient
                    id='cv'
                    x1='237.05'
                    x2='237.05'
                    y1='710.184'
                    y2='710.951'
                    gradientTransform='matrix(1 0 0 -1 0 1080)'
                    gradientUnits='userSpaceOnUse'>
                    <stop offset='0' stopColor='#F57E20'></stop>
                    <stop offset='0.287' stopColor='#F8993C'></stop>
                    <stop offset='0.583' stopColor='#FBB259'></stop>
                    <stop offset='0.832' stopColor='#FDC16B'></stop>
                    <stop offset='1' stopColor='#FEC771'></stop>
                  </linearGradient>
                  <path
                    fill='url(#cv)'
                    d='M258.7 369.2v.7h-43.3v-.7c0-.1.1-.1.1-.1h43.1c.1-.1.1 0 .1.1'></path>
                  <path
                    fill='#FAA63A'
                    d='M258.7 369.8h-43.3v-.7c0-.1.1-.1.1-.1h43.1c.1 0 .1.1.1.1zm-43.3 0h43.3v-.6c0-.1 0-.1-.1-.1h-43.1c-.1 0-.1 0-.1.1z'
                    className='st249'></path>
                </g>
                <path
                  fill='#788A9A'
                  d='M215.4 371.6h43.3v.3h-43.3z'
                  className='st250'></path>
                <path
                  fill='#576E82'
                  d='M258.7 371.6h6.1v.3h-6.1z'
                  className='st223'></path>
                <path
                  fill='#979E38'
                  d='M259.8 382.5c-.1.7-.7 1.1-1.3 1.2h-.7c-.2-.1-.3-.2-.5-.3s-.3-.3-.4-.5c-.1-.3-.2-.6-.1-.9.1-.8.9-1.3 1.6-1.2h.1c.9.1 1.5.9 1.3 1.7'
                  className='st251'></path>
                <path
                  fill='#979E38'
                  d='M263 382v.2c0 .1-.1.2-.1.4 0 .1-.1.2-.1.3-.3.4-.7.7-1.1.9-.3.1-.6.1-.9.1h-.2c-.7-.2-1.2-.8-1.4-1.5-.1-.3-.1-.5 0-.8 0-.1.1-.3.1-.4.1-.2.1-.3.2-.4.1-.2.3-.3.5-.5q.6-.45 1.5-.3c.4.1.8.3 1.1.6s.5.8.4 1.4'
                  className='st251'></path>
                <path
                  fill='#717832'
                  d='M263 382v.2c0 .1-.1.2-.1.4 0 .1-.1.2-.1.3-.3.4-.7.7-1.1.9-.3.1-.6.1-.9.1h-.2c-.7-.2-1.2-.8-1.4-1.5-.1-.3-.1-.5 0-.8 0-.1.1-.3.1-.4.1-.2.1-.3.2-.4 0 0-.2 1.1.8.7 1-.3 1.5 0 1.8.4.1.2.6.4.9.1'
                  className='st252'
                  opacity='0.25'></path>
                <path
                  fill='#979E38'
                  d='M258.6 384.2c-.1.3-.2.5-.5.6-.1 0-.2.1-.3.1h-.3c-.5-.1-.8-.5-.7-1 0-.2.2-.4.4-.5s.4-.2.6-.1h.2c.3.1.4.3.5.6.1.1.1.2.1.3'
                  className='st251'></path>
                <path
                  fill='#717832'
                  d='M258.6 383.9h-.6c-.2-.1-.5-.2-.6-.4.1.1.3.2.5.3h.7c-.1 0 0 0 0 .1M259.1 382.1v.2h-.2v-.6000000000000001c0-.2.1-.5.3-.7 0 .1-.1.2-.1.4z'
                  className='st253'></path>
                <path
                  fill='#979E38'
                  d='M261.6 384v.4c-.1.3-.2.6-.4.9l-.4.4s-.1 0-.1.1c-.2.1-.3.1-.5.2-.2 0-.5.1-.7 0-.5-.1-.9-.4-1.2-.8s-.4-.9-.3-1.4v-.1c0-.2.1-.4.2-.5.2-.3.4-.5.7-.7h.2c.3-.1.6-.1 1-.1.4.1.7.3 1 .5l.1.1.1.1c.2.3.3.6.4.9-.1-.1-.1-.1-.1 0'
                  className='st251'></path>
                <path
                  fill='#717832'
                  d='M258.9 382.4c-.5.3-.9.7-1 1.3h-.1v-.1c.1-.6.5-1 1-1.3h.1zM261.4 382.8c-.1 0-.1.1-.2.1-.3-.3-.7-.6-1.1-.7s-.7 0-1 .1h-.1c.1-.1.2-.1.3-.1.3-.1.7-.2 1-.1.5.1.9.3 1.1.7'
                  className='st253'></path>
                <path
                  fill='#979E38'
                  d='M264.7 384.9q0 .15 0 0c-.3 1.1-1.3 1.8-2.4 1.6-.6-.1-1.1-.5-1.4-1-.2-.4-.3-.9-.2-1.3s.2-.7.5-1c.3-.4.8-.6 1.3-.7h.6c.5.1.9.3 1.2.7.3.5.5 1.1.4 1.7'
                  className='st251'></path>
                <path
                  fill='#717832'
                  d='M261.5 384.9c0 .1 0 .2-.1.2s-.1-.1-.1-.2 0-.2.1-.2c0 0 .1.1.1.2M260 384.6c-.1.1-.1.1-.2.1s0-.1 0-.2c.1-.1.1-.1.2-.1zM262.5 382.5c-.4 0-.7.2-1 .4-.1 0-.1.1-.2.1-.3.3-.6.7-.7 1.2v.2c0 .4 0 .8.2 1.1l-.1.1s-.1 0-.1.1q-.45-.6-.3-1.5v-.1c0-.1.1-.2.1-.3.2-.4.4-.7.8-.9.1 0 .1-.1.2-.1.4-.2.7-.3 1.1-.3'
                  className='st253'></path>
                <path
                  fill='#A6A938'
                  d='M264.1 383.9c-.2.3-.7-.2-.8-.5 0-.3-.2-.4-.4-.3s-.5.2-.6 0c-.1-.1 0-.2.1-.3s.3-.2.5-.2h.2c.3.1.5.2.7.3.3.2.4.6.3 1M261.1 382.7c-.1.1-.2.2-.3.1-.2-.1-.3-.1-.3.2s-.6.3-.9-.3c-.3-.5-.8.5-1.2.5-.2 0-.2-.1-.2-.3.2-.3.4-.5.7-.7h.2c.3-.1.6-.1 1-.1.4.2.8.4 1 .6'
                  className='st254'></path>
                <path
                  fill='#717832'
                  d='M260.7 385.7c-.2.1-.3.1-.5.2-.2 0-.5.1-.7 0-.5-.1-.9-.4-1.2-.8s-.4-.9-.3-1.4v-.1c.1 0 .3 0 .4.3.2.5.7.9 1 .5s.6-.5 1-.3v.1q-.15.75.3 1.5M264.7 385c-.2 1.1-1.3 1.8-2.4 1.6-.6-.1-1.1-.5-1.4-1-.2-.4-.3-.9-.2-1.3s.2-.7.5-1c0 0-.4.9.2.9s1.7-.4 1.5.5.4 1.4.7 1c.2-.6.7-1.2 1.1-.7'
                  className='st252'
                  opacity='0.25'></path>
                <path
                  fill='#A6A938'
                  d='M258.5 380.7c0 .2-.2.4-.3.3-.2 0-.1 0-.4.2-.2.2.3.3.2.6 0 .4-.3.2-.5.1s-.1.6-.3.9c-.1.1-.1.1-.2 0-.1-.3-.2-.6-.1-.9.1-.7.8-1.3 1.6-1.2M262.2 380.3c.2.1 0 .4-.2.3-.1-.1-.2-.1-.2-.2-.2-.3-.2 0-.4.4s-.4-.2-.6-.4c-.1-.2-.5.3-.7.2 0 0-.1 0-.1-.1-.1-.1 0-.3.1-.3.4-.2.8-.3 1.3-.2.3 0 .6.1.8.3'
                  className='st254'></path>
                <path
                  fill='#AD5C74'
                  d='m262.3 387.7-1.4 1.3.1 3.2v.7l-1-.4.3-7-.5-.9h.1l.7.9.7-.5-.6.6.1 2.9 1.3-.9zq.15 0 0 0'
                  className='st255'></path>
                <path
                  fill='#979E38'
                  d='M262.9 387.4c0 .2-.1.4-.2.6-.2.3-.5.4-.8.4-.6 0-1-.4-1-1 0-.1 0-.3.1-.4q.3-.6.9-.6c.6 0 1 .4 1 1'
                  className='st251'></path>
                <path
                  fill='#979E38'
                  d='M263.4 388.5c0 .1 0 .2-.1.3-.1.3-.4.6-.8.6-.5 0-.9-.4-.9-.9v-.1c0-.1 0-.1.1-.2.1-.2.2-.4.4-.4.1 0 .1 0 .2-.1h.3c.4 0 .7.3.8.7z'
                  className='st251'></path>
                <path
                  fill='#979E38'
                  d='M263.7 387.7c0 .1 0 .2-.1.3l-.3.3c-.1 0-.1.1-.2.1h-.1c-.2 0-.4-.1-.5-.2s-.2-.3-.2-.5v-.1c0-.1 0-.2.1-.3l.3-.3c.1 0 .2-.1.3-.1.4.1.7.4.7.8'
                  className='st251'></path>
                <path
                  fill='#717832'
                  d='M262.7 387c-.2.1-.4.3-.4.6-.1 0-.1 0-.2.1.1-.3.3-.6.6-.7'
                  className='st253'></path>
                <path
                  fill='#717832'
                  d='M263.7 388c-.1.2-.3.4-.5.4h-.1c-.4 0-.7-.3-.7-.7 0-.1 0-.2.1-.3-.1.2-.1.4.2.4.4 0 .6-.1.6.1 0 .1.2.3.4.1M262.4 387.3c-.1.1-.1.2-.1.3-.1 0-.1 0-.2.1-.2.1-.4.4-.5.7-.4-.1-.8-.5-.8-1 0-.1 0-.3.1-.4.1 0 .2-.1.3.2.1.4.2.6.4.4.2-.1.6-.3.8-.3'
                  className='st252'
                  opacity='0.25'></path>
                <path
                  fill='#717832'
                  d='M263.3 388.8c-.1.3-.4.6-.8.6-.5 0-.9-.4-.9-.9v-.1c0-.1 0-.1.1-.2.1 0 .3 0 .3.2.1.4.2.8.4.5.2-.2.4-.4.4-.2s0 .4.1.2c.2-.2.2-.4.4-.1q0-.15 0 0'
                  className='st252'
                  opacity='0.25'></path>
                <path
                  fill='#814262'
                  d='m260.1 392.5.3-7-.5-.9.6 1v6.2c0 .3.2.5.4.6h.1v.7zM260.9 389l-.1.2.2 1.9zM261.4 385l-.6.6v-.1zc0-.1 0 0 0 0'
                  className='st256'
                  opacity='0.5'></path>
                <path
                  fill='#979E38'
                  d='M252.4 391.5v.4c-.2.7-.8 1.2-1.5 1.2-.8 0-1.5-.6-1.6-1.3v-.3c0-.6.4-1.2.9-1.4.1 0 .1-.1.2-.1.2-.1.3-.1.5-.1.5 0 1 .3 1.3.7l.1.1s0 .1.1.1z'
                  className='st251'></path>
                <path
                  fill='#979E38'
                  d='M255.3 390.3c0 .5-.2.9-.4 1.2l-.2.2s-.1.1-.2.1c-.3.2-.7.3-1 .3-.8 0-1.4-.4-1.7-1.1-.1-.2-.2-.5-.2-.8 0-.8.4-1.4 1.1-1.7.2-.1.5-.2.8-.2.6 0 1.1.3 1.5.7.1.4.3.9.3 1.3'
                  className='st251'></path>
                <path
                  fill='#979E38'
                  d='M257.5 391.1c0 .6-.3 1-.7 1.3-.2.2-.5.3-.8.3-.8 0-1.5-.7-1.5-1.5 0-.2 0-.4.1-.5.1-.2.2-.5.4-.6.1-.1.2-.1.3-.2.2-.1.5-.2.7-.2.5 0 1 .3 1.3.7.1.1.2.4.2.7'
                  className='st251'></path>
                <path
                  fill='#717832'
                  d='M254.4 391.1c0 .2.1.5.2.7 0 0-.1.1-.2.1-.1-.2-.2-.4-.2-.7 0-.5.3-1 .7-1.3-.3.3-.5.7-.5 1.2'
                  className='st253'></path>
                <path
                  fill='#979E38'
                  d='M252.7 389.7c0 .3-.1.6-.3.8 0 .1-.1.1-.2.1-.1.1-.3.2-.4.2h-.4c-.2 0-.4-.1-.5-.2-.3-.2-.5-.5-.6-.8v-.4c.1-.6.6-1 1.2-1 .3 0 .5.1.7.2.3.2.4.5.5.8z'
                  className='st251'></path>
                <path
                  fill='#717832'
                  d='M251.4 390.9h-.1c-.2 0-.4-.1-.6-.2-.3-.2-.5-.4-.6-.7.1 0 .1-.1.2-.1.1.3.3.6.6.8.1.2.3.2.5.2M252.8 389.8c0 .4-.2.8-.5 1 0 0 0-.1-.1-.1.3-.2.5-.6.5-1s-.2-.7-.5-.9c.4.2.6.6.6 1'
                  className='st253'></path>
                <path
                  fill='#717832'
                  d='M257.5 391.2c0 .5-.3.9-.7 1.2-.2.2-.5.3-.8.3-.6 0-1.1-.3-1.4-.8-.1-.2-.2-.4-.2-.7 0-.2 0-.3.1-.5.2-.1.5-.2.7.1.2.4.1.9.5.7.5-.2.8-.6 1-.3.2.2.4.3.8 0q-.15 0 0 0'
                  className='st252'
                  opacity='0.25'></path>
                <path
                  fill='#717832'
                  d='M254.6 391.8s-.1.1-.2.1c-.3.2-.7.3-1 .3-.4 0-.7-.1-1-.3 0-.1.1-.3.1-.4 0-.3-.1-.5-.2-.8.1 0 .1-.1.2-.1s.3.1.3.4c.2.5.4.7.7.4.2-.2.7-.5 1-.3-.1.2 0 .5.1.7'
                  className='st252'
                  opacity='0.25'></path>
                <path
                  fill='#A6A938'
                  d='M257.2 390.3c-.2.1-.8 0-1-.4-.3-.4-.5.1-.9.2-.2 0-.2-.1-.2-.2s.1-.2.2-.2c.2-.1.4-.1.6-.1.6 0 1.1.3 1.3.7M254.9 389.1q0 .15 0 0c-.2.5-.8.1-1-.2s-.5-.2-.9 0c-.2.1-.3-.1-.3-.3.2-.1.5-.2.8-.2.5 0 1 .3 1.4.7'
                  className='st254'></path>
                <path
                  fill='#717832'
                  d='M252.7 389.7c0 .3-.1.6-.3.8 0 .1-.1.1-.2.1-.1.1-.3.2-.4.2h-.4c-.2 0-.4-.1-.5-.2-.3-.2-.5-.5-.6-.8v-.4c.1-.1.2-.2.4 0 .2.3.6.6.7.4.2-.3.3-.6.6-.3.2.3.5.3.7 0z'
                  className='st252'
                  opacity='0.25'></path>
                <path
                  fill='#717832'
                  d='M252.4 391.7v.1c-.2.7-.8 1.2-1.5 1.2-.8 0-1.5-.6-1.6-1.3.2 0 .5-.1.7.2.2.4.9.7 1.2.4s.4-.9.7-.5c0 .2.3 0 .5-.1'
                  className='st253'></path>
                <path
                  fill='#979E38'
                  d='m268.3 396.9-22.7.1s-.2-.6.2-1.5c.4-.8 1.2-1.8 3-2.7 0 0 5.5-3.1 10.1-.8 2.1 1.1 3.8 1.8 5.2 2.2 1 .3 1.8.5 2.4.7 1 .1 1.8 1 1.8 2'
                  className='st251'></path>
                <path
                  fill='#717832'
                  d='m268.3 396.9-22.7.1c.2-1 .7-1.9 1.6-2.4 1.3-.9 3.2-1.9 3.7-1.1.7 1.3 1.9 1.9 3.6.8 1.8-1 4.7-1.7 5.2-.6.5 1-.1 2.4 2.3 1.2h.1c1-.5 2.3-.6 3.4-.3.5.1.8.2 1.2.3.8.1 1.6 1 1.6 2'
                  className='st252'
                  opacity='0.25'></path>
                <linearGradient
                  id='cw'
                  x1='229.65'
                  x2='229.65'
                  y1='683.062'
                  y2='689.849'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9CD0F1'></stop>
                  <stop offset='0.536' stopColor='#B1D9F4'></stop>
                  <stop offset='1' stopColor='#C7E4F7'></stop>
                </linearGradient>
                <path
                  fill='url(#cw)'
                  d='M242.8 393.2v-.4c0-.5-.3-.9-.7-1.1v-.3c0-.7-.6-1.2-1.2-1.2-.7 0-1.3.6-1.3 1.2v.1h-.5c-.2 0-.4 0-.5.1-.2-.3-.6-.6-1-.6-.6 0-1 .4-1.1.9v.2c-.1 0-.2-.1-.3-.1h-.2c-.1 0-.2.1-.3.2-.1-.7-.7-1.3-1.4-1.3-.6 0-1.2.4-1.3 1h-.4c-.1-.5-.6-.9-1.1-.9-.6 0-1.1.5-1.1 1.1v.2c-.2 0-.3 0-.5.1s-.3.2-.4.3c-.1-.6-.6-1-1.3-1-.6 0-1.2.5-1.3 1-.2-.1-.4-.1-.5-.1 0-1.1-.9-2-2-2-.7 0-1.2.3-1.6.8-.1.1-.1.2-.2.3-.4-.3-1-.5-1.6-.5-.9 0-1.7.4-2.2 1.1-.2.3-.4.7-.5 1.1 0 0-.1 0-.1-.1-.2-.1-.5-.1-.7-.1-1 0-1.7.8-1.7 1.8s.8 1.8 1.8 1.8c.5 0 1-.2 1.3-.6.1-.1.1-.2.2-.3.5.5 1.2.8 1.9.8.8 0 1.4-.3 1.9-.8l.2-.2c.1.8.7 1.4 1.5 1.4.7 0 1.3-.5 1.5-1.1h.8c.1 0 .3-.1.4-.2.3.4.8.6 1.3.6.6 0 1.2-.4 1.4-.9.2.5.7.9 1.2.9.6 0 1.1-.4 1.3-1 .1 0 .2 0 .3.1h.1c.6 0 1.2-.3 1.5-.8.2.3.6.6 1 .6s.8-.2 1-.6l.1.1c.2.2.5.3.7.3.3 0 .5-.1.7-.2.3.3.8.6 1.3.6.4 0 .8-.1 1.1-.3l.2-.2c.1.7.7 1.2 1.5 1.2.2 0 .4 0 .6-.1.5-.2.9-.7.9-1.3 0-.9-.3-1.4-.7-1.6'></path>
                <path
                  fill='#BBDDF5'
                  d='M219.1 395.7c-.1.1-.1.2-.2.3-.5-.5-.8-1.2-.8-1.9 0-.3 0-.6.1-.9 0 0 .1 0 .1.1 0 .2-.1.4-.1.5.1.8.4 1.4.9 1.9M225.8 394.1c-.4.6-1.2.9-2 .8-.8-.2-1.4-.8-1.6-1.6-.1-.7.1-1.4.6-1.9-.3.4-.5 1-.4 1.6.1.9.8 1.5 1.7 1.7.6 0 1.3-.2 1.7-.6'
                  className='st258'
                  opacity='0.5'></path>
                <path
                  fill='#BBDDF5'
                  d='M224.8 394.2v.3h-.2v-.3c0-.7.4-1.2 1-1.5 0 0 .1 0 .1-.1-.5.5-.9 1-.9 1.6M226.8 395.8c-.2.1-.4.1-.6.1-.8 0-1.4-.6-1.6-1.3h.2c.2.7.8 1.3 1.6 1.3.2-.1.3-.1.4-.1M229.5 393.2c0 .3-.1.7-.3.9 0 .1-.1.1-.2.1-.2.2-.5.3-.8.3-.7 0-1.3-.6-1.3-1.3v-.1c.1.7.6 1.2 1.3 1.2.3 0 .5-.1.7-.2.1 0 .1-.1.2-.1.2-.2.4-.5.4-.8 0-.1 0 0 0 0M230.7 394.9c-.2.1-.3.1-.5.1-.5 0-1-.3-1.2-.7.1 0 .1-.1.2-.1.2.5.7.8 1.2.8.1-.1.2-.1.3-.1M238.7 391.5c-.7.2-1.3.9-1.3 1.7h-.1c.1-.8.6-1.5 1.4-1.7M240.7 393.8c-.1.2-.1.4-.1.6v.2l-.2.2v-.3c0-.2 0-.4.1-.6 0-.1.1-.1.2-.1-.1-.2 0-.2.1-.3 0 0 0 .1.1.1-.2.1-.2.2-.2.2M240.4 392.8c-.4-.2-.8-.6-.8-1.1v-.2h.1c0 .5.3.8.7 1 .1.1 0 .2 0 .3M232.8 395.3h-.1c-.9 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7h.1c-.9.1-1.6.8-1.6 1.7s.7 1.7 1.6 1.7M234.2 393.8q0 .15 0 0c-.7 0-1.2-.6-1.2-1.3v-.3.1c0 .7.5 1.2 1.2 1.5 0-.1 0 0 0 0'
                  className='st258'
                  opacity='0.5'></path>
                <path
                  fill='#BBDDF5'
                  d='M235.6 392.6s0 .1 0 0h-.3c-.6 0-1.1.4-1.2 1v.2-.5c.1-.6.6-1 1.2-1h.3z'
                  className='st258'
                  opacity='0.5'></path>
                <path
                  fill='#BBDDF5'
                  d='M235.6 392.6s0 .1 0 0h-.2c0-.3.3-.6.6-.6-.2.1-.4.4-.4.6M237.5 393.5c-.5-.1-.9-.6-.9-1.2 0-.2 0-.3.1-.5v.3c0 .5.4 1 .9 1.1-.1.2-.1.2-.1.3M236.6 394c0 .2 0 .4-.1.5l-.1-.1c.1-.2.2-.4.2-.6v-.3c0 .1.1.1.1.2-.1.1-.1.2-.1.3M242.8 393.1v.1c-.1.6-.6 1.1-1.2 1.1-.4 0-.7-.2-.9-.4 0-.1.1-.1.1-.2.2.2.5.4.9.4.5-.1.9-.5 1.1-1 0-.1 0 0 0 0'
                  className='st258'
                  opacity='0.5'></path>
                <linearGradient
                  id='cx'
                  x1='222.9'
                  x2='222.9'
                  y1='683.037'
                  y2='686.65'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9CD0F1'></stop>
                  <stop offset='0.536' stopColor='#B1D9F4'></stop>
                  <stop offset='1' stopColor='#C7E4F7'></stop>
                </linearGradient>
                <path
                  fill='url(#cx)'
                  d='M243.3 393.6v3.3h-40.8v-.1c0-1.8 1.4-3.3 3.2-3.4 2.3-.1 5.2-.1 6.8.6.5.2 1.2.3 2.1.4 4.8.3 15-1.1 21.8-1.1 1.8 0 4.2.2 6.9.3'></path>
                <defs>
                  <path d='M1 1h1L1 2z'></path>
                </defs>
                <defs>
                  <path d='M-1-1h-1l1-1z'></path>
                </defs>
                <clipPath id='cy'>
                  <path d='M1 1h1L1 2z' overflow='visible'></path>
                </clipPath>
                <clipPath id='cA' clipPath='url(#cy)'>
                  <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                </clipPath>
                <defs>
                  <filter
                    id='cz'
                    width='28.7'
                    height='6.3'
                    x='214.6'
                    y='388.2'
                    filterUnits='userSpaceOnUse'>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'></feColorMatrix>
                  </filter>
                </defs>
                <mask
                  id='cF'
                  width='28.7'
                  height='6.3'
                  x='214.6'
                  y='388.2'
                  maskUnits='userSpaceOnUse'>
                  <g filter='url(#cz)'>
                    <defs>
                      <path d='M1 1h1L1 2z'></path>
                    </defs>
                    <defs>
                      <path d='M-1-1h-1l1-1z'></path>
                    </defs>
                    <clipPath id='cB' clipPath='url(#cA)'>
                      <path d='M1 1h1L1 2z' overflow='visible'></path>
                    </clipPath>
                    <clipPath id='cD' clipPath='url(#cB)'>
                      <path d='M-1-1h-1l1-1z' overflow='visible'></path>
                    </clipPath>
                    <linearGradient
                      id='cC'
                      x1='228.971'
                      x2='228.971'
                      y1='685.536'
                      y2='691.812'
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'>
                      <stop offset='0'></stop>
                      <stop offset='0.109' stopColor='#141414'></stop>
                      <stop offset='0.333' stopColor='#484848'></stop>
                      <stop offset='0.653' stopColor='#9D9D9D'></stop>
                      <stop offset='1' stopColor='#FFF'></stop>
                    </linearGradient>
                    <path
                      fill='url(#cC)'
                      d='M243.3 389.7v3.9c-2.7-.2-5.1-.3-6.8-.3-6.8 0-16.9 1.4-21.8 1.1-.1-.7-.4-3.7 2.7-3.8 3.5-.1 5.7-2.9 8.3-1.4 2.5 1.5 6.1 1.1 8.5-.1s4.6-1.2 5.7-.2 3.4.8 3.4.8'
                      clipPath='url(#cD)'></path>
                  </g>
                </mask>
                <linearGradient
                  id='cE'
                  x1='228.971'
                  x2='228.971'
                  y1='685.536'
                  y2='691.812'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0'></stop>
                  <stop offset='0.109' stopColor='#141414'></stop>
                  <stop offset='0.333' stopColor='#484848'></stop>
                  <stop offset='0.653' stopColor='#9D9D9D'></stop>
                  <stop offset='1' stopColor='#FFF'></stop>
                </linearGradient>
                <path
                  fill='url(#cE)'
                  d='M243.3 389.7v3.9c-2.7-.2-5.1-.3-6.8-.3-6.8 0-16.9 1.4-21.8 1.1-.1-.7-.4-3.7 2.7-3.8 3.5-.1 5.7-2.9 8.3-1.4 2.5 1.5 6.1 1.1 8.5-.1s4.6-1.2 5.7-.2 3.4.8 3.4.8'
                  clipPath='url(#cA)'
                  mask='url(#cF)'></path>
                <linearGradient
                  id='cG'
                  x1='228.971'
                  x2='228.971'
                  y1='685.536'
                  y2='691.812'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#FFF'></stop>
                  <stop offset='0.444' stopColor='#E7F3FB'></stop>
                  <stop offset='1' stopColor='#C7E4F7'></stop>
                </linearGradient>
                <path
                  fill='url(#cG)'
                  d='M243.3 389.7v3.9c-2.7-.2-5.1-.3-6.8-.3-6.8 0-16.9 1.4-21.8 1.1-.1-.7-.4-3.7 2.7-3.8 3.5-.1 5.7-2.9 8.3-1.4 2.5 1.5 6.1 1.1 8.5-.1s4.6-1.2 5.7-.2 3.4.8 3.4.8'
                  enableBackground='new'
                  opacity='0.5'></path>
                <linearGradient
                  id='cH'
                  x1='255.8'
                  x2='255.8'
                  y1='683.037'
                  y2='683.953'
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'>
                  <stop offset='0' stopColor='#9CD0F1'></stop>
                  <stop offset='0.536' stopColor='#B1D9F4'></stop>
                  <stop offset='1' stopColor='#C7E4F7'></stop>
                </linearGradient>
                <path fill='url(#cH)' d='M243.3 396h25v.9h-25z'></path>
              </g>
              <path
                fill='none'
                stroke='#000'
                strokeMiterlimit='10'
                d='M357.324-150.74h-174.4c-3.9 0-7.1-2.69-7.1-5.98v-68.61c0-3.28 3.2-5.98 7.1-5.98h174.5c3.9 0 7.1 2.7 7.1 5.98v68.61c0 3.37-3.2 5.98-7.2 5.98ZM704.776-153.52H577.344c-3.248 0-5.914-2.54-5.914-5.66v-56.17c0-3.1 2.666-5.65 5.914-5.65h127.432c3.249 0 5.914 2.55 5.914 5.65v56.17c0 3.12-2.665 5.66-5.914 5.66Z'
                className='st15'></path>
              <text
                fill='#2E3192'
                className='st8 st6 st268'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='22.17'
                style={{
                  whiteSpace: "pre",
                  lineHeight: "35.4725px",
                  perspectiveOrigin: "19.2px 0",
                }}
                transform='translate(775.626 -164.997)'>
                {data[67] ? data[67]["suvi"] : "0"}
                {` m\u00B3/s`}
              </text>
              <path
                fill='none'
                stroke='#000'
                strokeMiterlimit='10'
                d='M886.361-154.56h-121.81c-3.111 0-5.664-2.51-5.664-5.55v-54.92c0-3.06 2.553-5.55 5.664-5.55h121.81c3.111 0 5.664 2.49 5.664 5.55v54.92c0 3.04-2.553 5.55-5.664 5.55ZM1053.25-151.96H930.886c-3.125 0-5.69-2.53-5.69-5.62v-55.67c0-3.08 2.565-5.61 5.69-5.61h140.364c3.13 0 5.69 2.53 5.69 5.61v55.67c0 3.09-2.56 5.62-5.69 5.62Z'
                className='st15'></path>
              <path
                fill='#FFF'
                stroke='#000'
                strokeMiterlimit='10'
                d='M996.735 289.374h-188.38c-4.21 0-7.664-2.838-7.664-6.298v-72.297c0-3.459 3.454-6.298 7.664-6.298h205.38c4.215 0 7.665 2.839 7.665 6.298v72.297c.1 3.46-3.35 6.298-7.665 6.298Z'
                className='st23'></path>
              <text
                x='813.491'
                y='231.166'
                className='st4 st270'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "34.8085px", whiteSpace: "pre" }}>
                Qoraqum kanali
              </text>
              <text
                fill='#2E3192'
                className='st8 st6 st9'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='matrix(1.03862 0 0 1.02381 823.17 267.082)'>
                {`${data[648] ? data[648]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <path
                fill='#FFF'
                stroke='#000'
                strokeMiterlimit='10'
                d='M658.097 201.542H485.056c-3.868 0-7.041-2.594-7.041-5.755v-66.052c0-3.161 3.173-5.754 7.041-5.754h180.041c3.867 0 7.041 2.593 7.041 5.754v66.052c.099 3.242-3.074 5.755-7.041 5.755Z'
                className='st23'></path>
              <text
                x='494.685'
                y='150.833'
                className='st4 st272'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23.7'
                style={{
                  whiteSpace: "pre",
                  lineHeight: "37.9323px",
                  perspectiveOrigin: "28.8px 0",
                }}>
                Lebab viloyati
              </text>
              <text
                x='1192.45'
                y='518.666'
                fill='#2E3192'
                className='st8 st6 st273'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ lineHeight: "36.4962px", whiteSpace: "pre" }}
                transform='translate(-689.237 -332.24)'>
                {`${data[654] ? data[654]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <path
                fill='#FFF'
                stroke='#000'
                strokeMiterlimit='10'
                d='M563.285 316.209H345.457c-4.867 0-8.862-2.596-8.862-5.76V244.34c0-3.163 3.995-5.759 8.862-5.759h240.828c4.869 0 8.864 2.596 8.864 5.759v66.109c0 3.164-3.995 5.76-8.864 5.76ZM107.627-23.126H-19.59c-3.304 0-6.014-3.323-6.014-7.373v-71.761c0-4.05 2.71-7.37 6.014-7.37h127.217c3.303 0 6.014 3.32 6.014 7.37v71.761c0 4.05-2.711 7.373-6.014 7.373ZM-114-24.791h-148.33c-3.49 0-6.36-3.381-6.36-7.502v-73.017c0-4.11 2.87-7.49 6.36-7.49h148.42c3.49 0 6.34 3.38 6.34 7.49v73.017c0 4.121-2.85 7.502-6.43 7.502ZM-140.3-132.92h-160.2c-3.9 0-7.1-2.65-7.1-5.87v-57.14c0-3.22 3.2-5.87 7.1-5.87h160.2c3.9 0 7.1 2.65 7.1 5.87v57.14c0 3.22-3.2 5.87-7.1 5.87ZM-411.59 234.775h-182.03c-4.72 0-8.6-3.936-8.6-8.734v-85.126c0-4.798 3.88-8.734 8.6-8.734h182.14c4.74 0 8.62 3.936 8.62 8.734v85.003c0 4.921-3.88 8.857-8.73 8.857ZM-216.61 161.932h-127.14c-3.3 0-6.01-2.707-6.01-6.005V97.486c0-3.299 2.71-6.005 6.01-6.005h127.14c3.3 0 6.01 2.706 6.01 6.005v58.441c0 3.298-2.71 6.005-6.01 6.005ZM-134.61 339.081h-166.25c-4.32 0-7.86-2.655-7.86-5.89v-57.323c0-3.235 3.54-5.889 7.86-5.889h166.25c4.32 0 7.86 2.654 7.86 5.889v57.323c0 3.235-3.54 5.89-7.86 5.89ZM-333-132.92h-150.1c-3.9 0-7.1-2.69-7.1-5.96v-58.02c0-3.27 3.2-5.96 7.1-5.96h150.2c3.9 0 7.1 2.69 7.1 5.96v58.02c0 3.27-3.2 5.96-7.2 5.96Z'
                className='st23'></path>
              <text
                fill='#2E3192'
                className='st8 st6 st273'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(351.142 300.195)'>
                {`${data[679] ? data[679]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <path
                fill='#FFF'
                stroke='#000'
                strokeMiterlimit='10'
                d='M389.396 461.681h-180.5c-3.9 0-7.1-3.2-7.1-7.1v-81.5c0-3.9 3.2-7.1 7.1-7.1h174.5c3.9 0 7.1 3.2 7.1 7.1v81.5c0 3.9-3.2 7.1-7.1 7.1Z'
                className='st23'></path>
              <g
                fill='#2E3192'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'>
                <text
                  className='st8 st6 st273'
                  fontSize='22.81'
                  style={{ whiteSpace: "pre", lineHeight: "36.4962px" }}
                  transform='translate(290.069 449.658)'>
                  {`${data[678] ? data[678]["suvi"] : "0"} m\u00B3/s`}
                </text>
              </g>
              <text
                x='340.674'
                y='265.986'
                className='st4 st275'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "34.6141px", whiteSpace: "pre" }}>
                Turkmandaryo kanali
              </text>
              <text
                x='218.46'
                y='395.162'
                className='st4 st276'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23.7'
                style={{ whiteSpace: "pre", lineHeight: "37.8925px" }}>
                Chap qirg’oq
              </text>
              <text
                x='218.46'
                y='420.425'
                className='st6 st277'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='21.1'
                style={{ whiteSpace: "pre", lineHeight: "33.6822px" }}>
                kanali
              </text>
              <text
                x='-7.178'
                y='-79.595'
                className='st4 st278'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "43.1614px", whiteSpace: "pre" }}>
                QQR N/S
              </text>
              <text
                x='710.631'
                y='281.686'
                fill='#2E3192'
                className='st8 st6 st280'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(-714.042 -318.681)'>
                {`${data[163] ? data[163]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <text
                x='-263.73'
                y='-87.13'
                className='st4 st282'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "31.6061px", whiteSpace: "pre" }}>
                Qipchoq G/p
              </text>
              <g
                fill='#2E3192'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'>
                <text
                  x='480.78'
                  y='250.913'
                  className='st8 st6 st283'
                  style={{ lineHeight: "28.0942px", whiteSpace: "pre" }}
                  transform='translate(-740.912 -310.094)'>
                  {`H - ${data[715] ? data[715]["suvi"] : "0"} sm`}
                </text>
                <text
                  className='st8 st6 st283'
                  style={{ whiteSpace: "pre" }}
                  transform='translate(-258.565 -35.767)'>
                  {`Q - ${data[716] ? data[716]["suvi"] : "0"} m\u00B3/s`}
                </text>
              </g>
              <text
                x='-480.56'
                y='-172.35'
                className='st4 st285'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "35.3962px", whiteSpace: "pre" }}>
                Do’stik kanali
              </text>
              <text
                fill='#2E3192'
                className='st8 st6 st286'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(-439.91 -144.617)'>
                {`${data[171] ? data[171]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <text
                x='-299.82'
                y='-174.94'
                className='st4 st288'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "38.3565px", whiteSpace: "pre" }}>
                Anasoy kanali
              </text>
              <text
                fill='#2E3192'
                className='st8 st6 st289'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(-249.259 -144.963)'>
                {`${data[174] ? data[174]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <text
                x='-594.86'
                y='158.67'
                className='st8 st4 st291'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "27.4614px", whiteSpace: "pre" }}>
                Paralelniy va
              </text>
              <text
                x='-596.82'
                y='192.956'
                className='st8 st4 st291'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "27.4614px", whiteSpace: "pre" }}>
                Suenli kanallari
              </text>
              <g
                fill='#2E3192'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'>
                <text
                  className='st8 st6 st291'
                  fontSize='20'
                  style={{ whiteSpace: "pre" }}
                  transform='translate(-591.783 219.447)'>
                  {`${add(
                    data[183] ? data[183]["suvi"] : 0,
                    data[172] ? data[172]["suvi"] : 0
                  )} m\u00B3/s`}
                </text>
              </g>
              <text
                x='-310.4'
                y='118.702'
                className='st35 st293'
                fontFamily='Poppins-Medium'
                fontSize='23'
                style={{ lineHeight: "45.4026px", whiteSpace: "pre" }}>
                GRES
              </text>
              <text
                x='367.329'
                y='481.261'
                fill='#2E3192'
                className='st8 st6 st294'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(-676.421 -333.602)'>
                {`${data[175] ? data[175]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <text
                x='-299.26'
                y='299.467'
                className='st4 st296'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "36.4965px", whiteSpace: "pre" }}>
                Xonyap kanali
              </text>
              <text
                x='336.939'
                y='654.029'
                fill='#2E3192'
                className='st8 st6 st297'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(-628.744 -327.336)'>
                {`${data[721] ? data[721]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <path
                fill='#FFF'
                stroke='#000'
                strokeMiterlimit='10'
                d='M-1.064 431.924H-190.01c-4.44 0-8.08-2.754-8.08-6.111v-59.469c0-3.357 3.64-6.111 8.08-6.111H-.120c4.441 0 8.086 2.754 8.086 6.111v59.469c0 3.357-3.645 6.111-8.2 6.111Z'
                className='st23'></path>
              <text
                x='479.464'
                y='735.287'
                fill='#2E3192'
                className='st8 st6 st297'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(-645.16 -315.11)'>
                {`${data[720] ? data[720]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <path
                fill='#FFF'
                stroke='#000'
                strokeMiterlimit='10'
                d='M147.898 336.081H-30.554c-4.634 0-8.436-2.529-8.436-5.612v-54.615c0-3.083 3.802-5.612 8.436-5.612h178.452c4.634 0 8.435 2.529 8.435 5.612v54.615c0 3.083-3.683 5.612-8.435 5.612Z'
                className='st23'></path>
              <text
                x='629.525'
                y='655.034'
                fill='#2E3192'
                className='st8 st6 st297'
                fontFamily="'Poppins', sans-serif"
                fontWeight='400'
                fontSize='20'
                style={{ whiteSpace: "pre" }}
                transform='translate(-650.445 -328.642)'>
                {`${data[706] ? data[706]["suvi"] : "0"} m\u00B3/s`}
              </text>
              <text
                x='-180.32'
                y='385.712'
                className='st4 st299'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "35.9672px", whiteSpace: "pre" }}>
                Jumaboy kanali
              </text>
              <text
                x='-29.556'
                y='298.203'
                className='st4 st300'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "35.1366px", whiteSpace: "pre" }}>
                Qilichboy kanali
              </text>
              <text
                x='1001.41'
                y='-66.364'
                className='st4 st301'
                fontFamily="'Poppins', sans-serif"
                fontWeight='=600'
                fontSize='23'
                style={{ lineHeight: "26.0624px", whiteSpace: "pre" }}>
                Termiz G/p
              </text>
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
}

export default Page2;

const add = (a, b) => {
  if (!a || typeof a === "undefined") {
    a = 0;
  }
  if (!b || typeof b === "undefined") {
    b = 0;
  }
  let c = parseFloat(a) + parseFloat(b);
  if (c % 1 === 0) {
    return c;
  }
  return c.toFixed(2);
};
